<script>
	import { onMount } from "svelte";
	import { elasticOut } from "svelte/easing";
	import { fade } from "svelte/transition";
	import { onDestroy } from "svelte";
	import { springIn, springOut } from "svelte-helpers/spring-transitions";
	import Header from "./Header.svelte";
	import Switch from './Switch.svelte';
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
	import { push, replace } from 'svelte-spa-router'
	import { loader } from './loader';
	let content_loading = writable(true);

	const power_avail = tweened(0, {
		duration: 600,
		easing: cubicOut
	});

	const progress = tweened(0, {
		duration: 200,
		easing: cubicOut
	});

	const progress_factor = tweened(0, {
		duration: 400,
		easing: cubicOut
	});

	let recharge_mebot_url = '';
	import { writable } from 'svelte/store';
	import Modal, { bind } from 'svelte-simple-modal';
	import RechargeMebot from './RechargeMebot.svelte';
	import UnhatchedMebot from './UnhatchedMebot.svelte';
	import PopupMebot from './PopupMebot.svelte';
	import PopupPlain from './PopupPlain.svelte';
	const modal = writable(null);
	const modal1 = writable(null);

	import { sparkle_img } from './SparkleImg.svelte'

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

	// The params prop contains values matched from the URL
	export let params = {};

	let dash_token = params.t;
	let reset = params.r;
	let mebot_loc = params.m;

	let city_code = null;
	if (dash_token != '1') {
		if (getCookie("m_dash_token") != '') {
			dash_token = getCookie("m_dash_token")
		}
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
	}
	let mebot_id = params.id;
	mebot_id = getCookie('m_id');
	let mebot_url;
    if (!mebot_url) {
        mebot_url = getCookie('mebot_img_url');
    }

	let has_loaded = false;
	let habitats = [];
	let is_loading = false;
	let is_loadings = [];
//	let hab_visited_today = '1 habitat';
	let hab_visited_today = '0 habitats';
	let total_dist = '0';
	let total_dist_max = '1';
	let total_dist_in_square = '';
	let show_claim = false;
	let show_places_today = false;
	let parsecs_disp = 'parsecs';
	let habitats_empty = '';
	let mebot_img_url = getCookie("mebot_img_url");
	let city_control = '';
	let city_guilds = '';
	let cur_guild = '';
	let cur_guild_stats = '';
	let cities_n = 0;
	let guilds_n = 0;

	let zombie_eaten = false;
	let flip_box_border = 'flip_box_border1';
	let flip_box_front = 'flip-box-front1';
	let audio;
	let boost_audio;
	let selected;
	let selected_id;
	let selected_set = [];
	let selected_rare_set = [];
	let selected_set_tmp = [];
	let last_symbol_id = -1;
	let tapped = 0;
	let tapped_max = 20;
	let tapped_i = -1;
	let last_tapped_i = -1;
	let game_size = 289;
	let game_row_size = 17;
	let zoom = 2;
	let default_zoom = -1;
	let zoom_level_desc = '';
	let res_desc = '';
	let o_x = 0;
	let o_y = 0;
	let lo_x = 0;
	let lo_y = 0;
	let cx = -1;
	let cy = -1;
	let cpos = -1;
	let cur_hab_id = 0;
	let cur_hab_url = '';
	let map_filter = 5;
	let city_stats = [];
	let is_live = 0;
	let show_is_live = false;
	let is_live_tracking_on = false;
	let live_i = 0;
	let map_control = '';
	let map_explored = '';
	let is_anon = 0;
	let center_image = '';
	let is_user_pos = 0;

	let entities = [];
	let ents_tmp = [];
	let ents_xy = -1;

	let mebot_md = [];

	let my_mebot_img_url = null;

	if (getCookie("is_anon") == 1) {
		is_anon = 1;
	}

	let news_badge_n = 0;

	let habitat_meters = '';
	let habitat_direction = '';

	let zoom_cookie = getCookie("map_zoom");
	if (zoom_cookie != '') {
		zoom = Number(zoom_cookie)
	}
	let map_filter_cookie = getCookie("map_filter");
	if (map_filter_cookie != 0) {
		map_filter = Number(map_filter_cookie)
	}
	let map_o_x = getCookie("map_lo_x");
	if (map_o_x != 0) {
		lo_x = Number(map_o_x)
	}
	let map_o_y = getCookie("map_lo_y");
	if (map_o_y != 0) {
		lo_y = Number(map_o_y)
	}
	if (reset == 1) {
		//zoom = 0; lo_x = 0; lo_y = 0;
	}
	if (reset == 2) {
		//values are reset in #go/
	}

	city_code = getCookie("city_code");
	if (reset.length > 2) {
		city_code = reset;
		setCookie("city_code", city_code, 1);

		if (getCookie("map_zoom") == '') {
			zoom = -3;
		}
	}
	console.log('city: ' + city_code);

//	let game_size = 10000;
//	let game_row_size = 100;

	game_size = 81;
	game_row_size = 9;

	let game_size_active = 81;
	let game_row_size_active = 9;
//	let game_size_active = 289;
//	let game_row_size_active = 17;
	let found_rare = 0;
	let rare_symbol = "";
	let collected_n = 0;
	let collected_str = "";
	let collected_rare_str = "";
	let game_play_time = 45;
	let play_time = game_play_time;
	let time_remaining = play_time;
	let original_play_time = play_time;
	let extra_time = 0;
	let start_time = Math.floor(Date.now() / 1000);
	let cur_time = Math.floor(Date.now() / 1000);
	let _number_of_mebots = 12;
	let sparkle_count = 0;
	let is_rebuilding = 0;
	let border_id = 1;
	let owner_id = -1;
	let speed_factor = 1;
	let nominal_speed_factor = 0;
	let watts_level = 0;
	let autopilot_level = 0;
	let watts_count = 0;
	let watts_calc = 0;
	let auto_targets = [];
	let timeout_id;
	let watts_e = false;
	//console.log(cur_time);
	//$:console.log(selected)

	let landTiles = [];
	let landTilesFinal = [];
	let border = 0;
	let prize = 0;

	let mebotee = [];
	let mebotee_pos = [];
	let mebots_moving = true;
	let mebot_pos = [];
	let calculated_pos = [];
	let last_mebot_pos = [];
	let last_mebot_dir = [];
	let next_mebot_pos = [];
	let boosts_left = [];
	let dir = [];
	let dirs = [];
	let x_offset = 0;
	let y_offset = 0;
	let target_tile = 0;
	let target_tile_x = 0; let target_tile_y = 0; let owner_x = 0; let owner_y = 0;
	let row = 0;
	let last_tap = -1;
	let current_tap = -1;
	let prize_n = 0;
	let minimum_steps = 0;
	let steps_remaining = minimum_steps;
	let steps_taken = 0;
	let large_sparkle_img = '/img/sparkle-200-large.png';
	let mebot_winner_img_url = [];
	let mebot_winner_score = [];
	let mebot_winner_id = [];
	let _default_delay = 220;
	let delay = _default_delay;
	let boost_left = 0;
	let clocks_n = 0;
	let zombies_n = 0;
	let zombie_prev = 0;
	let wormhole_n = 0;
	let watts_n = 0;
	let steps_took = 0;
	let is_flashing = false;
	let is_sparkle_flash = false;
	let auto_roam = false;
	$: auto_roam, saveAutopilot();

	let auto_assigned = false;
	let show_close = true;
	let progress_n = 20;
	let embark_to_hid = 0;
	let embark = [];
	embark['em'] = '';
	embark['info'] = '';
	embark['steps_away'] = 0;

	let journey = [];
	journey['info'] = '';
	journey['info_full'] = '';
	journey['distance'] = '';
	journey['chat_cmd'] = '';
	journey['chat_cmd_id'] = '';
	journey['state_id'] = '';
	journey['mode_id'] = '';
	journey['n_items'] = '';
	journey['visited'] = '';
	let just_collected = false;
	let just_collected_visted = '';

	getHabitats()
	fetchMapHabitats()
	load_game()

	let touchstartX = 0
	let touchendX = 0
	let touchstartY = 0
	let touchendY = 0
	let pan_enabled = true;
	let scaling = false;
	let done_scaling = true;
	let pinch_start = 0;
	let pinch_end = 0;
	let flash_minus = false;
	let flash_plus = false;
	let view_stats_id = 0;

	let mebots = [];
	let show_mebots = false;
	let map_menu = false;

	let modes = [];
	let open_modes_menu = false;
	let mebots_loading = false;

	function checkDirection() {

		//console.log('done_scaling: ' + done_scaling)
		if (pan_enabled == false) {
			return;
		}
		if (Math.abs(touchendY-touchstartY) < 40 && Math.abs(touchendX-touchstartX) < 40) {
			return;
		}
		if (!done_scaling) {
			return;
		}

		if (scaling) {
			done_scaling = false;
			let incc = Math.ceil(Math.abs(pinch_end-pinch_start)/100)

			if (pinch_end > pinch_start) {
				zoomMap(incc)
			} else {
				zoomMap(incc * -1)
			}
			setTimeout(function(){ done_scaling = true; scaling = false; }, 50);
			return;
		}

		let inc = 1;
		o_y = 0;
		o_x = 0;

	if (Math.abs(touchendY-touchstartY) < Math.abs(touchendX-touchstartX)) {
//		if (Math.abs(touchendX - touchstartX) > 100) inc = 2;
//		if (Math.abs(touchendX - touchstartX) > 150) inc = 3;
		if (touchendX < touchstartX) {
			o_x = o_x - inc;
			fetchMapHabitats();
		}
		if (touchendX > touchstartX) {
			o_x = o_x + inc;
			fetchMapHabitats();
		}
		//setCookie("map_o_x", o_x, 1);
	} else {
//		if (Math.abs(touchendY - touchstartY) > 100) inc = 2;
//		if (Math.abs(touchendY - touchstartY) > 150) inc = 3;
		if (touchendY < touchstartY) {
			o_y = o_y - inc;
			fetchMapHabitats();
		}
		if (touchendY > touchstartY) {
			o_y = o_y + inc;
			fetchMapHabitats();
		}
		//setCookie("map_o_y", o_y, 1);
	}
	}

	const controller = new AbortController();
	const { signal } = controller;

	onMount(() => {
		console.log('loading touch')
		loadTouch();
	});

	function loadTouch() {

		//if (alpha_mebot()) {
		if (true) {

		const map = document.getElementById('mapp');
		//console.log(map)

		map.addEventListener('touchstart', e => {
			touchstartX = e.changedTouches[0].screenX
			touchstartY = e.changedTouches[0].screenY
			if (e.touches.length === 2 && scaling == false) {
				scaling = true;
				pinch_start = Math.floor(Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY));
			}
		}, { signal })

		map.addEventListener('touchmove', e => {
			if (e.touches.length === 2) {
				pinch_end = Math.floor(Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY))
			}
		}, { signal })

		map.addEventListener('touchend', e => {
			touchendX = e.changedTouches[0].screenX
			touchendY = e.changedTouches[0].screenY
			checkDirection()
		}, { signal })

		}
	}

	document.onkeydown = function(event) {
		o_y = 0;
		o_x = 0;
		switch (event.keyCode) {
			case 38: // arrow up
			o_y = +1;
			fetchMapHabitats();
			break;
		case 40: // arrow down
			o_y = -1;
			fetchMapHabitats();
			break;
		case 37: // arrow left
			o_x = +1;
			fetchMapHabitats();
			break;
		case 39: // arrow right
			o_x = -1;
			fetchMapHabitats();
			break;
		case 107: // plus char
		case 187: // plus char
			zoomMap(1)
			break;
		case 109: // minus char
		case 189: // minus char
			zoomMap(-1)
			break;
		//case 16: showMap = true; break; // left shift (show map)
		}
	}

	function alpha_mebot() {

		//return false;
		//return true;
		let m_id = mebot_id;

		//if m_id == 76 || m_id == 87 || m_id == 250 || m_id == 110 || m_id == 1 || m_id == 308 || m_id == 368}
		//if (m_id == 76 || m_id == 87 || m_id == 250 || m_id == 1 || m_id == 110 || m_id == 338) {
		if (m_id == 76 || m_id == 87 || m_id == 1 || m_id == 110 || m_id == 338) {
				return true;
		}
		return false;
	}

	async function centerMap() {
		mebot_loc = 0;
		//zoomMap(0);
		replace("/go/2/map");
	}

	function showNorth() {

		show_mebots = false;
		map_menu = false;
		open_modes_menu = false;
		centerMap();
		return;

		displayMebotMessage(`
		<center>
			<br><br>
			<b>North ⬆️</b>
			<br><br><br>
		</center>`, 7000, 'Center map', centerMap);
	}

	function showCityControl() {
		show_mebots = false;
		map_menu = false;
		open_modes_menu = false;
		displayMebotMessagePlain(`
		<center>
			<br><br>
			` + city_control + `
			<br><br>
		</center>`, 16, 50000, '  ♾️   ');
	}

	function showCityGuilds() {
		show_mebots = false;
		map_menu = false;
		open_modes_menu = false;
		displayMebotMessagePlain(`
		<center>
			<br><br>
			` + city_guilds + `
			<br><br>
		</center>`, 16, 25000, '  ♾️   ');
	}

	function displayParsecDetails() {

		let steps_took = '';
		if (steps_taken != '') {
			steps_took = `and took <span style="color: gold;">` + steps_taken + ` steps</span>`;
		}
//			<img src='` + my_mebot_img_url + `' width=100 height=100 alt=''><br><br>

		displayMebotMessage(`
		<center>
			<br><br>
			<b> <span style="color: lightblue;">` + total_dist + ` Parsecs</span></b>
			<br><br>
			<span style="color: lightblue;">0&nbsp;&nbsp;` + total_dist_in_square + `&nbsp; ` + total_dist_max + `</span><br>
			<br>
			Your mebot traveled <span style="color: lightblue;">` + total_dist + ` parsecs</span> ` + steps_took + ` in the last 12 hours.
			<br><br>
			<span style="color: lightblue;">Parsecs</span> are a unit of distance in Land42.<br><br>
		     <i>Visit more habitats to increase parsecs traveled.</i>
			<br><br><br>
		</center>`, 10000);
	}

	function displayHabitatsToday() {
		displayMebotMessage(`
		<center>
			<br><br>
			<b> ` + hab_visited_today + `</b>
			<br><br>
			Your mebot visited <b>` + hab_visited_today + `</b> in the last 12 hours.<br><br> Setup or find more habitats today!
			<br><br><br>
		</center>`, 7000);
	}

	async function restartGame() {
		auto_targets = [];
		border_id = 1;
		flip_box_border = 'flip_box_border' + border_id%5;
		flip_box_front = 'flip-box-front' + border_id%5;
		selected_set = [];
		selected_rare_set = [];
		selected_set_tmp = [];
		last_symbol_id = -1;
		tapped = 0;
		tapped_max = 20;
		tapped_i = -1;
		last_tapped_i = -1;
		game_size = 225;
		game_row_size = 15;
		game_size_active = 81;
		game_row_size_active = 9;
		found_rare = 0;
		rare_symbol = "";
		collected_n = 0;
		collected_str = "";
		collected_rare_str = "";
		play_time = game_play_time;
		time_remaining = play_time;
		extra_time = 0;
		start_time = Math.floor(Date.now() / 1000);
		cur_time = Math.floor(Date.now() / 1000);
		landTiles = [];
		landTilesFinal = [];
		border = 0;
		prize = 0;
		mebotee = [];
		mebots_moving = true;
		mebot_pos = [];
		last_mebot_pos = [];
		last_mebot_dir = [];
		next_mebot_pos = [];
		dir = [];
		x_offset = 0;
		y_offset = 0;
		target_tile = 0;
		target_tile_x = 0; let target_tile_y = 0; let owner_x = 0; let owner_y = 0;
		row = 0;
		last_tap = -1;
		current_tap = -1;
		prize_n = 0;
		sparkle_count = 0;
		clocks_n = 0;
		zombies_n = 0;
		wormhole_n = 0;
		watts_n = 0;
		owner_id = -1;
		speed_factor = 1;
		load_game()
		await fetchActiveMebots();
		update_board()
		delay = _default_delay;
		boost_left = 0;
		boosts_left = [];
		mebot_winner_img_url = [];
		mebot_winner_score = [];
		mebot_winner_id = [];
		steps_taken = 0;
	}

	async function reloadBoard() {
		is_rebuilding = 1;
		border_id++;
		if (border_id > 4) {
			border_id = 1;
		}
		flip_box_border = 'flip_box_border' + border_id%5;
		flip_box_front = 'flip-box-front' + border_id%5;
		if (border_id == 2) {
			//flip_box_border = 'text-electric-wormhole2';
		}
		selected_set = [];
		selected_rare_set = [];
		selected_set_tmp = [];
		last_symbol_id = -1;
		tapped = 0;
		tapped_max = 20;
		tapped_i = -1;
		last_tapped_i = -1;
		found_rare = 0;
		rare_symbol = "";
		collected_n = 0;
		collected_str = "";
		collected_rare_str = "";
		landTiles = [];
		landTilesFinal = [];
		border = 0;
		prize = 0;
		mebots_moving = true;
		target_tile = 0;
		target_tile_x = 0; let target_tile_y = 0; let owner_x = 0; let owner_y = 0;
		row = 0;
		last_tap = -1;
		current_tap = -1;
		sparkle_count = 0;
		clocks_n = 0;
		zombies_n = 0;
		wormhole_n = 0;
		watts_n = 0;
		auto_targets = [];
		load_game()
		delay = _default_delay;
		await sleep(600);

		for (let i = 1; i <= _number_of_mebots; ++i) {
			if (mebots[i-1].is_owner == 1) {
				if (landTiles[mebot_pos[i]].s == -1) {
					sparkle_count--;
					mebots[i-1].prize_n++;
					prize_n = mebots[i-1].prize_n;
					is_sparkle_flash = true;
				}
				landTiles[mebot_pos[i]].s = i;
				dirs[i] = []
			}
		}
		is_rebuilding = 0;

		if (auto_targets.length > 0 && auto_targets.length > autopilot_level) {
			//console.log('limiting ' + auto_targets)
			if (autopilot_level-2 <= 0) {
				auto_targets = []
			} else {
				auto_targets.slice(0, autopilot_level*2-2)
			}
			//console.log('to: ' + auto_targets)
		}

	}

	function load_game() {
		let found_tile = 0;
		for (let i = 0; i < game_size; i++) {
		prize = 0;
		found_tile = 0;
//		if (i%game_row_size == 0 || i%game_row_size == (game_row_size-1) || i < game_row_size || i >= game_size-game_row_size) {
		if (false) {
			border = 1;
			found_tile = - 1;
		} else {

			found_tile = 1;
			border = 0;

			//if (i != (1 * game_row_size + 1)) {

//			if (Math.floor(Math.random() * (Math.floor(Math.random() * 4 + 1)) + 1) == 2) {
				prize = -1;
				sparkle_count++;
//			}

/*
			//bolt
			if (Math.floor(Math.random() * 60 + 1) == 2) {
				if (prize == -1) {
					sparkle_count--;
				}
				prize = -2;
				auto_targets = [...auto_targets, i]
			}
			//extra time
			if (Math.floor(Math.random() * 40 + 1) == 2 && clocks_n < 4) {
				if (prize == -1) {
					sparkle_count--;
				}
				prize = -3;
				clocks_n++;
				//if (clocks_n <= 3) {
					auto_targets = [...auto_targets, i]
				//}
			}
*/

			//zombie
/*			if (Math.abs(i-zombie_prev) > 2 && (Math.abs(i-zombie_prev))%game_row_size != 0) {
				if (Math.floor(Math.random() * 50 + 1) == 3 && zombies_n < 10) {
					if (prize == -1) {
						sparkle_count--;
					}
					prize = -4;
					zombies_n++;
					zombie_prev = i;
					auto_targets = auto_targets.filter(item => item !== i)
				}
			}*/

			//wormhole
			/*
			if (Math.abs(i-zombie_prev) > 2 && (Math.abs(i-zombie_prev))%game_row_size != 0) {
				if (Math.floor(Math.random() * 1000 + 1) == 2 && wormhole_n < 1) {
					if (prize == -1) {
						sparkle_count--;
					}
					prize = -5;
					wormhole_n++;
					zombie_prev = i;
					auto_targets = auto_targets.filter(item => item !== i)
				}
			}

			if (watts_e && watts_n < 1 && Math.floor(Math.random() * 2000 + 1) == 3) {
				if (prize == -1) {
					sparkle_count--;
				}
				prize = -6;
				watts_n++;
			}
			*/

//			if (i == 40)
//				prize = -7;
			//}
		}
		landTiles.push({
			id: i,
			name: "",
			watts: "56",
			watt_level: "4",
			img: "/img/mebots-watts.png",
			s: prize,
			text: "",
			rarity: 0,
			found: found_tile,
			b: border
			//text: '𒈙',
		});
	}
	//console.log(auto_targets)

	}

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

	function update_board() {
		let landTilesFinal_tmp = [];
		for (let i = 0; i < game_row_size_active; i++) {
			landTilesFinal_tmp.push(...landTiles.slice(y_offset*game_row_size + x_offset + game_row_size*i, y_offset*game_row_size + x_offset +  game_row_size*i + game_row_size_active));
		}

		//landTilesFinal = landTilesFinal_tmp;
		landTilesFinal = landTilesFinal_tmp.slice(0, 9*8)
		//console.log(landTilesFinal)
	}
	update_board()

	function displayRechargeMessage() {
		clearTimeout(timeout_id);
		show_close = false
		modal.set(bind(RechargeMebot, { mebot_img_url: recharge_mebot_url }));
		timeout_id = setTimeout(function(){ modal.set(null); }, 5000);

		cur_time = Math.floor(Date.now() / 1000);
		time_remaining = play_time - cur_time + start_time;
		if (time_remaining > 5) {
			play_time = 5 + cur_time - start_time;
		}
		progress.set(0)
	}

	async function displayUnhatchedMessage() {
		clearTimeout(timeout_id);
		show_close = false
		modal.set(bind(UnhatchedMebot, { mebot_img_url: recharge_mebot_url }));
		timeout_id = setTimeout(function(){ modal.set(null); }, 6000);

		cur_time = Math.floor(Date.now() / 1000);
		time_remaining = play_time - cur_time + start_time;
		if (time_remaining > 3) {
			play_time = 3 + cur_time - start_time;
		}
		time_remaining = play_time - cur_time + start_time;
		await sleep(1000);
		time_remaining = 3;
		await sleep(1000);
		time_remaining = 2;
		await sleep(1000);
		time_remaining = 1;
		await sleep(1000);
		time_remaining = 0;

		await sleep(310);
		setWinners();
	}

    const onSetupHabitatAction = () => {
		setCookie("v_h_id", -1, 1)
		push("/dash/2/1");
    };

	const onShowHabitats  = () => {
		setCookie("v_h_id", -2, 1)
		push("/dash/2/1");
    };

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = false
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

	function displayMebotMessagePlain(msg, font_size, delay, action_button = false, action = null) {
		let is_show_close = false
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupPlain, { p_message: msg, font_size, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupPlain, { p_message: msg, font_size, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

	function displayZombieMessage() {
		show_close = false
		displayMebotMessage('Zombies 🧟🧟‍♀️🧟‍♂️ <br> snatched your Mebot! 😱', 3000)
		progress_factor.set(0)

		cur_time = Math.floor(Date.now() / 1000);
		time_remaining = play_time - cur_time + start_time;
		if (time_remaining > 3) {
			play_time = 3 + cur_time - start_time;
		}
		//displayMebotMessage('Your Mebot was eaten by<br> 🧟🧟‍♀️🧟‍♂️ ', 3000)
	}

	function displayFoundEgg() {
		show_close = true

		displayMebotMessage(`
		<center>
			<br><br>
			<b>Congrats!!!</b><br><br><br>
		<img src='/img/egg-winner1.png' width='300px' height='215px' alt='Congratulations'/><br><br>

		You discovered Mebot Egg!<br><br> 🏆 🥳 🎉<br><br>
		Go to your dashboard<br>
		to claim & hatch it!
		<br><br>
		<br><br>
		</center>`, 10000)

		saveGame(true)
		//		<a href="/#/dash/"><button>Hatch</button></a>
	}

	function displaySpeedFactorInfo() {
		show_close = false
		displayMebotMessage('<br><b>Your Mebot Speed Factor</b> <br><br><br> <b>' +  Number(watts_count) + ' Watts</b> ⚡<br> + <br> (Watt Level <b>' +  Number(watts_level) + '</b>)✖️10 = <b>' +  Number(watts_level*10) + ' Watts</b> ⚡<br><br>👇<br><br> Speed factor: <b>' + watts_calc + ' Watts</b> ⚡<br><br>', 5000)
	}

	function displayStepsInfo() {
		displayMebotMessage('<br><br> You have 👟 ' + numberWithCommas(steps_remaining) + ' steps left in your balance. <br><br><br>', 5000)
	}

	function displayAutopilot() {
		displayMebotMessage(`
		<center>
			<br><br>
		<b>Your Mebot Autopilot Level: ` + autopilot_level  + `</b><br><br>
		<img src='/img/watt-level-autopilot-200.png' width='200px' height='119px' alt='Watt level'/><br><br>

		Your Mebot's Watt Level 👇<br> Your Mebot's Autopilot Level<br>
		<br>
		You can upgrade Autopilot by redeeming your ✨<br>
		You can also improve your Autopilot Level by solving puzzles and matching Sumerian characters.<br><br>
		</center>`, 7000)
	}

	async function getHabitatDirections(hid) {
		const res = await fetch(
			"https://api.forever.today/?method=get_habitat_direction",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					mebot_id,
					habitat_id: hid
				}),
			}
		);

		const json = await res.json();
        habitat_meters = json.data.habitat.meters;
		habitat_direction = json.data.habitat.direction;
		embark = json.data.habitat.embark;
	}

	function setSpeed() {
		_default_delay = 220 - Math.floor(speed_factor/2)
		if (_default_delay < 100) _default_delay = 100;
		console.log('default delay ' + _default_delay)
		progress_factor.set(speed_factor/200)
	}

	function toggleAutopilot () {
		auto_roam = !auto_roam;
	}

	function saveAutopilot () {
		console.log('save auto: ' + auto_roam)
		setCookie("autopilot", auto_roam, 365);
	}

	function displayIntroMessage() {

		let intro_played = getCookie("intro1");
		if (intro_played != 'yes') {
			displayMebotMessage(`
			<br><br>
			<b>Welcome to Move!</b><br><br><br>
			<b>Help your Mebot explore 🧭 <br>Land42 with your steps 👟</b>
			<br><br>
			Collect &nbsp;✨ <br>
			Find Mebot egg &nbsp;🥚 <br>
			Watch out for &nbsp;🧟 <br>
			Set new high score! &nbsp;🏆

			<br><br><br>
			`, 10000, true)
		}
		setCookie("intro1", 'yes', 7);

		if (getCookie("autopilot") != '') {
			console.log('setting auto-pilot: ' + getCookie("autopilot"))
			//auto_roam = (getCookie("autopilot") === 'true');
			auto_roam = false;
		}
	}

	async function fetchLeaderboard() {

		const res = await fetch(
			"https://api.forever.today/?method=get_move_leaderboard",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.mebots;
	}

	const onGetAppAction = () => {

		setCookie("v_h_id", -3, 1)
		replace("/dash/2/1");
	};

	async function sendChatCmd(cmd_id = 0) {

		if (cmd_id > 0 && mebot_id > 0) {

		const res = await fetch(
			"https://api.forever.today/?method=send_chat_cmd",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
                    mebot_id,
					cmd_id
				}),
			}
		);

		}	
	}

	//send command and don't refresh
	async function sendCmd(cmd_id) {

		is_loadings[cmd_id] = true;

		if (cmd_id == 2) {
			journey['n_items'] = 0;
			just_collected = true;
			just_collected_visted = journey['visited'];
			journey['visited'] = '';
		}

		await sendChatCmd(cmd_id);
		const res = await fetch(
				"https://api.forever.today/?method=get_mebot_modes",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token: dash_token,
						mebot_id: mebot_id
					}),
				}
			);
		const json = await res.json();
		mebot_md = json.data.mebot_md;
		power_avail.set(mebot_md.dp/100);

		if (cmd_id == 2) {
			await getMyMebots();
			//refresh map after items have been collected
			await fetchMapHabitats();
		}

		is_loadings[cmd_id] = false;
	}

	async function goChat(cmd_id = 0) {

		if (cmd_id == 0) {
			cmd_id = journey['chat_cmd_id'];
		}
		//send command
		console.log('cmd: ' + cmd_id);

		if (cmd_id != '') {
			await sendChatCmd(cmd_id);
		}

		replace("/chat/2/1");
	}

	async function changeMode(mode_id = -1) {

		show_mebots = false;
		just_collected = false;
		just_collected_visted = '';

		if (mode_id == -1) {

			open_modes_menu = !open_modes_menu;
			content_loading.update(n => true);

			const res = await fetch(
				"https://api.forever.today/?method=get_mebot_modes",
				{
					method: "POST",
					body: JSON.stringify({
						dash_token: dash_token,
						mebot_id: mebot_id
					}),
				}
			);

			const json = await res.json();
			content_loading.update(n => false);

			mebot_md = json.data.mebot_md;
			modes = json.data.modes;

			if (mebot_md.dp > 0) {
				power_avail.set(mebot_md.dp/100);
			}

		}

		if (mode_id >= 1) {
			console.log('changing state with cmd_id: ' + mode_id)

			modes = [];
			content_loading.update(n => true);
			await sendChatCmd(mode_id);
			await fetchMapHabitats();
			//zoomMap(0);
			content_loading.update(n => false);
			open_modes_menu = false;

			replace('/go/2/map/0_' + mebot_id);
		}

		if (mode_id == 0) {
			replace('/go/2/map/0_' + mebot_id);
		}

	}

	function showJourney() {

		console.log('state: ' + journey['state_id']  + ' mode: ' + journey['mode_id'])

		if (journey['info_full'] != '') {

			if (journey['chat_cmd_id'] != '') {
				displayMebotMessage(`
		<center>
			<br>
			` + journey['info_full']  + `
		<br>
		</center>`, 20000, journey['chat_cmd'], goChat);

			} else {
				displayMebotMessage(`
		<center>
			<br>
			` + journey['info_full']  + `
		<br>
		</center>`, 20000, 'Okay')
			}

		}
	}

	const embarkOnJourney = () => {

		const res = fetch(
			"https://api.forever.today/?method=embark_on_journey",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token: dash_token,
					mebot_id: mebot_id,
					habitat_id: embark_to_hid
				}),
			}
		);

		modal1.set(bind(PopupMebot, { p_message: `
		<center>
			<br><br>
			I'm on the way to this <b>Undiscovered Habitat</b>!<br><br>

			<table width=240>
				<tr>
					<td align=center>
						<img src='` + mebot_url + `' width=100 height=100 alt='Mebot'>
					</td>
					<td align=center><span style='white-space: nowrap;'>➡️ &nbsp;</span></td>
					<td align=center>
						<img src='https://app.mebots.xyz/img/mebot_planet_500.png' width=100 height=100 style='border-radius: 20px;' alt='Habitat'>
					</td>
				</tr>
			</table>

		<br><br>
		</center>`, closeButton: true }));
		timeout_id = setTimeout(function(){ modal1.set(null); }, 5000);

	}

	const onHowToGetThereAction = () => {

		if (habitat_meters == 'open_app') {

			let action = null;
			let action_call = 'Okay';
			if (getCookie("is_anon") == 1) {
				action = onGetAppAction;
				action_call = 'Get app 📱';
			}

			displayMebotMessage(`
		<center>
			<br>
			<div class="text-electric" style="font-size: 65px;" >
				<div> 🧭 </div>
			</div>
			<br>
			` + habitat_direction + `
			<br><br>
		</center>`, 10000, action_call, action);

		} else {

		displayMebotMessage(`
		<center>
			<br>
			<div class="text-electric" style="font-size: 65px;" >
				<div> 🧭 </div>
			</div>
			<br>
			<b>This habitat</b>  ` +  habitat_meters + ` <br><br><b> ` + habitat_direction + ` </b>
			<br><br>
			` + embark['info'] + `
			<br><br>
		</center>`, 10000, 'Send your Mebot here ➡️', embarkOnJourney);

		}
    };

	async function displayUndiscovered(hid) {

		await getHabitatDirections(hid)
		embark_to_hid = hid;
	
		displayMebotMessage(`
		<center>
			<br><br>

			<b>Undiscovered Habitat</b><br><br>

			<img src='https://app.mebots.xyz/img/mebot_planet_500.png' width=140 height=140 alt=''><br><br>

			You can discover this habitat in these ways:<br><br>
			<i>
			1. By visiting this area IRL.<br><br>
			2. By playing Move game with your Mebot and discovering it that way.<br><br>
			3. By embarking with your Mebot on a journey there! </i> 🧳
			<br><br><br>
		</center>`, 20000, 'Send your Mebot 👉', onHowToGetThereAction);

	}

	function displaySetupHabitat(msg, type) {

		let button = 'Okay';
		let button_action = null;

		if (type == 2) {
			button = 'Yes!'
			button_action = onSetupHabitatAction;
		}

		displayMebotMessage(`
		<center>
			<br><br>

			` + msg  + `

			<br><br>
		</center>`, 10000, button, button_action);

	}

	function fetchHelp() {

		show_mebots = false;
		map_menu = false;
		open_modes_menu = false;

		//old
		//◻️ &nbsp (Transparent) &nbspArea of Land42 that your Mebots explored.<br><br>
		//	Your Mebots explored <b><font color="#00B4FF">`+ map_explored + `</font></b> so far.<br><br>
		//	🟩 &nbspHabitats that you visted IRL, the brighter the color the most recent the visit. Adjacent tiles to the habitat you visited also light up.<br><br>
		//	🟨 &nbspHabitats that you are a Mayor of and control. Adjacent tiles to the habitat you own also light up.<br><br>
		//	Your Mebots control <b><font color="#FFCE00">`+ map_control + `</font></b><br><br>
		//	🟦 &nbspHabitats near you yet to be discovered - you discover a habitat by visiting their location IRL and collect ✨ along the way!<br><br>
		//	<img src='https://app.mebots.xyz/img/mebot_planet_500.png' width=30 height=30 alt=''> Far away, undisovered habitats - get closer to discover them.<br><br>

		displayMebotMessagePlain(`
			<br><br>

			<center><b>Map Legend 🗺️</b><br><br><br></center>

			<b>What does each color signify in Land42?</b>
			<br><br>

			◻️ &nbsp (Transparent) &nbspArea of Land42 that your Mebots explored.<br><br>
			Your Mebots explored <b><font color="#00B4FF">`+ map_explored + `</font></b> so far.<br><br>
			🟩 &nbspHabitats that you (or your Mebot) visted IRL today, the brighter the color the most recent the visit. <br><br>
			🟦 &nbspHabitats yet to be discovered - you discover a habitat by visiting their location IRL (or sending your Mebot there) and collecting ✨ along the way!<br><br>
			<img src='https://app.mebots.xyz/img/mebot_planet_500.png' width=30 height=30 alt=''> Far away, undisovered
 habitats - get closer to discover them.<br><br>

		`, 16, 20000, 'Okay');

	}

	function displayDarkMatter() {

		displayMebotMessage(`
		<center>
			<br><br>

			<b>Dark Matter<br><br><font size=20> ⬛ </font> </b><br><br>

			<br>
		</center>`, 7000);
	}

	async function zoomMap(inc, abs = -1) {

		if (inc < 0) {
			flash_minus = true;
			setTimeout(function(){ flash_minus = false; }, 100);
		}
		if (inc > 0) {
			flash_plus = true;
			setTimeout(function(){ flash_plus = false; }, 100);
		}

		o_x = 0;
		o_y = 0;
		if (abs != -1) {
			zoom = abs * (-1)
		}

		if (inc == 0) {

			if (abs == -1) {
				zoom = 2;
			}

			lo_x = 0;
			lo_y = 0;
			setCookie("map_lo_x", lo_x, 1);
			setCookie("map_lo_y", lo_y, 1);

			//reset back to home city
			setCookie("city_code", " ", 1);
			city_code = null;
			//mebot_loc = 0;

			if (abs == -1 && is_live == 1) {
				liveFetchMapHabitats()
				setCookie("is_live_tracking_on", 'yes', 1);
				show_is_live = true;
			}
		} else {
			zoom = zoom + inc;
		}
		if (zoom > 2)
			zoom = 2;

		if (zoom < -20) {
			zoom = -20;
		}

		console.log('zoom: ' + zoom + ', o_x: ' + lo_x + ', o_y: ' + lo_y)
		setCookie("map_zoom", zoom, 1);

		fetchMapHabitats()
	}

	async function liveFetchMapHabitats() {

		if (getCookie("is_live_tracking_on") != 'yes') {

			for (live_i = 0; live_i < 1000; live_i++) {
				await sleep(2000)
				if (getCookie("is_live_tracking_on") == 'yes') {
					if (show_is_live) {
						try {
							await fetchMapHabitats();
						} catch (error) {
							//console.error(error);
						}
					}
				} else {
					break;
				}
			}
			setCookie("is_live_tracking_on", 'no', 1);
			show_is_live = false;
		}
	}

	async function fetchMapHabitats(single_thread = 0) {

		is_loading = true;

		const res = await fetch(
			"https://api.forever.today/?method=get_map_habitats",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
					zoom,
					o_x,
					o_y,
					lo_x,
					lo_y,
					filter: map_filter,
					city: city_code,
					mebot_loc: mebot_loc
				}),
			}
		);
		o_x = 0;
		o_y = 0;

		scaling = false;

		let habibi = [];
		const json = await res.json();
		let runners = json.data.habitats;
		for (const runner of runners) {
			habibi[runner.xy] =
			{
				id: runner.id,
				file_id: runner.file_id,
				url: runner.url,
				name: runner.name,
				s: runner.s,
				st_n: runner.st_n,
				v: runner.v,
				m: runner.m,
				x: runner.x,
				y: runner.y,
				xy: runner.xy,
				undis: runner.undis,
				ether: runner.e,
				gem_n: runner.gem_n,
				hid: runner.hid_id,
				bg: runner.bg,
				em: runner.em, //emoji
			};

			if (runner.em != '') {
				//console.log('art: ' + runner.em)
			}
		}

		default_zoom = json.data.zm_level;
		res_desc = json.data.res_desc;
		zoom_level_desc = json.data.zm_desc;
		lo_x = json.data.lo_x;
		lo_y = json.data.lo_y;
		cx = json.data.cx;
		cy = json.data.cy;
		cpos = cx+(-0)+(cy*game_row_size_active);
		center_image = json.data.center_i;
		is_user_pos = json.data.iup;

		//console.log(habibi)
		habitats = habibi;
		city_stats = json.data.city_stats;
		is_live = json.data.is_live;

		if (is_live == 1 && zoom == 2) {
			//show_is_live = true;
			//setCookie("is_live_tracking_on", 'yes', 1);
		} else {
			//don't
			show_is_live = false;
			setCookie("is_live_tracking_on", 'no', 1);
		}

		is_loading = false;
		setCookie("map_lo_x", lo_x, 1);
		setCookie("map_lo_y", lo_y, 1);

		console.log('zoom: ' + zoom + ', o_x: ' + lo_x + ', o_y: ' + lo_y + ', cx: ' + cx + ', cy: ' + cy + ', cpos: ' + cpos)

		map_control = json.data.map_control;
		map_explored = json.data.map_explored;
		city_control = json.data.city_control;
		city_guilds = json.data.city_guilds;
		cur_guild = json.data.cur_guild;
		cur_guild_stats = json.data.cur_guild_stats;
		cities_n = json.data.cities_n;
		guilds_n = json.data.guilds_n;

		has_loaded = true;

		news_badge_n = getCookie("news_badge_n");
		news_badge_n = json.data.news_badge_n;
		setCookie("news_badge_n", news_badge_n, 1);

		let show_map_control = getCookie("map_control");
		if (false && show_map_control != 'yes' && map_control != '') {

			displayMebotMessagePlain(`
			<br><br>

				<center><b>Land42 🗺️</b><br><br><br>
				<b>Your Mebots control <font color="lightblue">`+ map_control + `</font></b>
				<br><br>
				Setup more habitats to control more land.
				<br>
				</center>
			`, 16, 10000, 'Okay');

			setCookie("map_control", 'yes', 10);
		}

		//load map mebots
		runners = json.data.mebots;

		let meboti = [];
		mebotee_pos = [];
		for (const runner of runners) {

			if (runner.xy in meboti) continue;

			meboti[runner.xy] =
			{
				id: runner.m_id,
				xy: runner.xy,
				img: runner.url,
				is_owner: runner.is_owner,
				watts: 1,
				prize_n: 0,
				steps_n: 0,
				level: 1,
				speed_factor: 1,
				team_miami: (runner.is_owner == 1 ? runner.team == 'miami' : 0),
				team_nyc: (runner.is_owner == 1 ? runner.team == 'nyc' : 0),
				type: runner.type,
				badge: runner.badge,
			};

			mebotee_pos = [...mebotee_pos, runner]

			if (runner.xy < (9*8)) {
				//habitats[runner.xy].ether = 1;
				//landTilesFinal_tmp[runner.xy].s = 1;
			}
			//console.log('m id: ' + runner.m_id + ' url: ' + runner.url)
			//console.log('m id: ' + runner.m_id + '  ' + runner.xy);

		}
		mebotee = meboti;

		embark = json.data.embark;
		journey = json.data.journey;

		runners = json.data.ents;
		ents_tmp = [];
		for (const runner of runners) {

			//console.log(runner)
			if (Array.isArray(runner.habs)) {
				if (Array.isArray(ents_tmp[runner.xy])) {
					ents_tmp[runner.xy] = ents_tmp[runner.xy].concat(runner.habs);
				} else {
					ents_tmp[runner.xy] = runner.habs;
				}
			}
			if (Array.isArray(runner.mebs)) {
				if (Array.isArray(ents_tmp[runner.xy])) {
					ents_tmp[runner.xy] = ents_tmp[runner.xy].concat(runner.mebs);
				} else {
					ents_tmp[runner.xy] = runner.mebs;
				}
			}
		}
		entities = ents_tmp;
		//console.log(entities)
		if (zoom >= 2) {
			//mebot_roam();
		}
	}

	async function fetchMapFilter(filter) {

		setCookie("map_filter", filter, 1);
		o_x = 0;
		o_y = 0;
		map_filter = filter;
		fetchMapHabitats();
	}

	async function getHabitats(type_id = 1) {

		habitats = [];
		const res = await fetch(
			"https://api.forever.today/?method=get_habitats",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
					type_id
				}),
			}
		);

		let habibi = [];
		const json = await res.json();
		let runners = json.data.habitats;
		for (const runner of runners) {
				habibi.push({
				id: runner.id,
				file_id: runner.file_id,
				url: runner.url,
				name: runner.name,
				s: runner.s,
				st_n: runner.st_n
				});
		}

		if (type_id == 1) {
			if (habibi.length == 1)
				hab_visited_today = '☀️ ' + habibi.length + ' habitat ';
			else
				hab_visited_today = '☀️ ' + habibi.length + ' habitats ';

			if (habibi.length == 0) {
				hab_visited_today = '';
			}
		}

		if (type_id == 2) {
			let mayor_count = json.data.mayor_count;
			if (mayor_count == 1) {
				mayor_h_num = ' 1 habitat '
			} else {
				mayor_h_num = mayor_count + ' habitats '
			}
		}

		if (json.data.can_claim == 1 && type_id == 1) {
			show_claim = true;
			if (habibi.length > 7) {
				habibi = habibi.slice(habibi.length-7, habibi.length)
			}
		}
		if (json.data.can_claim == 0 && type_id == 1) {
			show_claim = false;
		}
		if (habibi.length > 8) {
			habibi = habibi.slice(habibi.length-8, habibi.length)
		}

//		habitats = habibi;
//		is_loading = false;

		if (json.data.current.id > 0) {
			cur_hab_id = json.data.current.id
			//cur_hab_url = "https://mebots.xyz/img/land42_" + cur_hab_id + "_500.png"
			//console.log(cur_hab_url)
			//if (cur_hab_id > 24) {
				cur_hab_url = json.data.current.url;
			//}
		}

		if (json.data.total_dist != '0') {
			total_dist = json.data.total_dist;
		}
		if (json.data.steps_taken != '') {
			steps_taken = json.data.steps_taken;
		}
		total_dist_in_square = json.data.total_dist_sq;
		total_dist_max = json.data.total_max;

		//	habitats = [];
		filterPlaces(type_id)
	}

	const filterPlaces = async (v) => {

		if (v == 1) {
			//Today
			show_places_today = true;
			if (habitats.length == 0) {
				habitats_empty = 'Bring your Mebot to a habitat today!'
			}
		}

		if (v == 2) {
			//Mayor
			show_places_today = false;

			//habitat_msg = '<span style="display: flex; align-items:center; justify-content: center" >  <img src="' + my_mebot_img_url + '" width="21px" style="margin-left: 2px; margin-right: 2px;" /> is the mayor of ' + mayor_h_num + ' 👑 </span>';
			habitat_msg = '<span style="display: flex; align-items:center; justify-content: center" > You are the mayor of ' + mayor_h_num + ' 👑 </span>';

			if (habitats.length == 0) {
				habitats_empty = 'Find new locations and setup habitats.<br><br> Your Mebot will become Mayor 👑'
			}
		}

		if (v == 3) {
			//Local
			show_places_today = false;
			habitat_msg = 'Nearby habitats';

			if (habitats.length == 0) {
				habitats_empty = 'No nearby habitats found'
			}
		}

		if (v == 4) {
			//Top habitats
			show_places_today = false;
			habitat_msg = 'Favorite habitats';

			if (habitats.length == 0) {
				habitats_empty = 'No favorite habitats found'
			}
		}

		if (v == 5) {
			clear_badge_n(0);

			//Discovered habitats
			show_places_today = false;
			habitat_msg = 'All discovered habitats';

			if (habitats.length == 0) {
				habitats_empty = 'Take more 👟`s and let your Mebot discover new habitats!'
			}
		}
	}


	function setWinners() {
		mebot_winner_img_url[1] = mebots[0].img;
		mebot_winner_score[1] = mebots[0].prize_n;
		mebot_winner_id[1] = mebots[0].id;
		mebot_winner_img_url[2] = mebots[1].img;
		mebot_winner_score[2] = mebots[1].prize_n;
		mebot_winner_id[2] = mebots[1].id;
		mebot_winner_img_url[3] = mebots[2].img;
		mebot_winner_score[3] = mebots[2].prize_n;
		mebot_winner_id[3] = mebots[2].id;
		progress.set(0)
	}

	function endGameEarly() {
		progress_factor.set(0)

		if (time_remaining > 0) {
			cur_time = Math.floor(Date.now() / 1000);
			time_remaining = play_time - cur_time + start_time;
			if (time_remaining > 1) {
				play_time = cur_time - start_time;
			}
		}
		displayMebotMessage("<br>🛑 &nbsp;Game ended!  <br><br>", 2000)
	}

	async function _mebot_walk(xy) {

		if (mebotee[xy].type == 2) {
			await sleep( Math.floor(Math.random() * 600) + 500);
		} else {
			await sleep( Math.floor(Math.random() * 1000) + 500 );
		}

		let tmp_mebotee = mebotee;

		if (xy in mebotee) {

			let m = mebotee[xy];
			delete tmp_mebotee[xy];
			//console.log(xy)

			mebotee = tmp_mebotee;

			let move_inc = 0;
			let dir = Math.floor(Math.random() * 4 + 1);

			if (dir == 1) {
				if ((xy+1) % 9 != 0) {
					move_inc = 1;
				}
			}
			if (dir == 2) {
				move_inc = 9;
			}
			if (dir == 3) {
				if ((xy) % 9 != 0) {
					move_inc = -1;
				}
			}
			if (dir == 4) {
				move_inc = -9;
			}

			mebotee[xy+move_inc] = m;
			_mebot_walk(xy+move_inc);
		}
	}

	function mebot_roam() {
		for (let i = 0; i < mebotee_pos.length; ++i) {

			if (i in mebotee_pos && mebotee_pos[i].xy in mebotee) {
				_mebot_walk(mebotee_pos[i].xy);
			}
		}
	}

	async function fetchActiveMebots() {
		//runners
		let type_id = 10;

		const res = await fetch(
			"https://api.forever.today/?method=get_mebot_pack",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					type_id,
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.mebots;
		let cal_speed_factor = 0;
		if (json.data.daily_steps_n < minimum_steps) {
			steps_remaining = minimum_steps;
		} else {
			steps_remaining = json.data.daily_steps_n;
		}
		let game_watts = json.data.attr;

		for (const runner of runners) {
			cal_speed_factor = Math.floor(runner.watt_level * 20) ;
			cal_speed_factor = cal_speed_factor + Number(runner.watts);
			if (cal_speed_factor > 200) cal_speed_factor = 200;
			//console.log(' Mebot ' +  runner.id + ' ('+ runner.watt_level +') -> cal_speed_factor: ' + cal_speed_factor)
			mebots.push({
				id: runner.id,
//				img: 'https://app.mebots.xyz/img/mebot_0_2_500.png',
				img: runner.mebot_img_url,
				is_owner: runner.is_owner,
				team_miami: (runner.is_owner == 0 ? runner.team == 'miami' : 0),
				team_nyc: (runner.is_owner == 0 ? runner.team == 'nyc' : 0),
				watts: runner.watts,
				prize_n: 0,
				steps_n: 0,
				level: runner.watt_level,
				speed_factor: cal_speed_factor
			});
			if (runner.is_owner == 1) {
				watts_count = runner.watts;
				watts_level = Number(runner.watt_level);
				if (isNaN(watts_level) || watts_level == '' || watts_level < 0) {
					watts_level = 0;
				}
				autopilot_level = watts_level;
				if (Number(runner.autopilot_level) > 0) {
					autopilot_level = runner.autopilot_level
					console.log('!!!autopilot ' + autopilot_level)
				}
				if (auto_targets.length > 0 && auto_targets.length > autopilot_level) {
					//console.log('limiting ' + auto_targets)
					if (autopilot_level-2 <= 0) {
						auto_targets = []
					} else {
						auto_targets.slice(0, autopilot_level*2-2)
					}
					//console.log('to: ' + auto_targets)
				}

				watts_calc = Number(watts_count) + Math.floor(10 * watts_level)
				console.log('watts level: ' + watts_level + ' calc: ' + watts_calc)
				recharge_mebot_url = runner.mebot_img_url;
				speed_factor = watts_calc
				nominal_speed_factor = watts_calc
				if (speed_factor > 200) speed_factor = 200;
				setSpeed()
			}

			//console.log('mebot speed factor: ' + cal_speed_factor);
		}
		if (steps_remaining <= 0) {
			displayRechargeMessage()
		}
		if (recharge_mebot_url == '') {
			displayUnhatchedMessage()
		}

		//var mask = 1 << 5; // gets the 6th bit
		var der = 1 << 1; // gets the 2nd bit
		if ((game_watts & der) != 0) {
			watts_e = true;
			// bit is set
		} else {
			// bit is not set
			watts_e = false;
		}

		let m_pos = 0;
		if (mebots_moving == true) {
			for (let i = 1; i <= _number_of_mebots; ++i) {
				if (mebots[i - 1].img != "") {

					if (i == _number_of_mebots ) {

						//place in third quadrant
						target_tile_x = Math.floor(Math.random() * 8 + 2);
						target_tile_y = Math.floor(Math.random() * (game_row_size-10) + 9);
						m_pos = target_tile_y * game_row_size + target_tile_x;
						console.log('placed ' + target_tile_x + ' mebot ' + target_tile_y + ' at: ' + m_pos)

					} else if (i >= 8) {

						//place in fourth quadrant
						target_tile_x = Math.floor(Math.random() * (game_row_size-10) + 9);
						target_tile_y = Math.floor(Math.random() * (game_row_size-10) + 9);
						m_pos = target_tile_y * game_row_size + target_tile_x;

					} else {
					m_pos = Math.floor(Math.random() * (x_offset+(game_size_active)) + x_offset + game_row_size + 1)
					row = m_pos%game_row_size_active;
					if (row < 1) row = 1;
					m_pos = row*game_row_size + Math.floor(Math.random() * 8 + 1);
					if (m_pos == (game_row_size + 1)) {
						m_pos++;
					}
					}

					if (mebots[i - 1].is_owner == 1) {
						m_pos = 1 * game_row_size + 1;
					}
					//m_pos = Math.floor(Math.random() * 200 + 17);
		
					boosts_left[i] = 0;
					mebot_pos[i] = m_pos;
					dir[i] = 2;
					update_board();
					await sleep(Math.floor(Math.random() * 100 + 1));

					if (mebots[i-1].is_owner == 1) {
						owner_id = i-1;
						if (landTiles[m_pos].s == -1) {
							sparkle_count--;
							mebots[i-1].prize_n++;
							prize_n = mebots[i-1].prize_n;
							is_sparkle_flash = true;
						}
						landTiles[m_pos].s = i;
						dirs[i] = []
					}

					mebot_walk(i);
				}
			}
		}
	}

	async function saveGame(watt_r = false) {
		is_flashing = false;
		is_sparkle_flash = false;

		//watt_r => found_egg (true)
		let mebot_stats = JSON.stringify(mebots);
		const res = await fetch(
			"https://api.forever.today/?method=save_move_game",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
					steps_taken,
					prize_n,
					mebot_stats,
					watt_r
				}),
			}
		);
	}

	let cardBackShowing = false;

	function arrayRemove(arr, value) {
		return arr.filter(function (ele) {
			return ele != value;
		});
	}

	function viewStats(id) {
		push('/stats/2/' + mebot_id + '/' + view_stats_id);
	}

	function enterMap42(mebot_loc_id) {
		push('/map42/2/1/' + mebot_loc_id);
	}

	function viewEnt(i) {

		if (entities[ents_xy][i].link.length < 40) {
			//show mebot on map42
			console.log('link: ' + entities[ents_xy][i].link.length )
			let mebot_loc_id = entities[ents_xy][i].id
			enterMap42(mebot_loc_id)
			return;
		}

		console.log('viewing: ' + i + ' link: ' + entities[ents_xy][i].link)
		if (entities[ents_xy][i].link != '') {
			push(entities[ents_xy][i].link)
		}
	}

	function viewMebot(i) {

		if (i in mebotee) {

			if (mebotee[i].badge != '') {
				map_menu = true;
				open_modes_menu = false;
				ents_xy = mebotee[i].xy;
				return;
			}

			let img_src = mebotee[i].img
			view_stats_id = mebotee[i].id

			displayMebotMessage(`
			<center>
			<br><br>

			<img src='` + img_src + `' width=100 height=100 alt=''><br>

			<br><br>
			</center>`, 5000, 'View Stats 📈', viewStats);
		}
	}

	const toggleBackFront = async (e) => {
		selected = Number(e.target.dataset.cardId)

		//console.log('user_pos: ' + is_user_pos)

		//is_user_pos designates that map is now show user's position (and not mebot's)
		if (!scaling && selected != 40 && is_user_pos == 1 && selected == cpos && ( !(selected in habitats) || habitats[selected].id == -3 )) {
			displaySetupHabitat(' Your current location 📍<br><br> Do you want to setup Habitat here? ', 2);
			console.log('clicked center: ' + selected)
			return;
		}

		if (!scaling && selected == 40) {
			if (lo_x == 0 && lo_y == 0) {
				//only if empty spot or visited/mayor/miami/nyc tile
				if (is_user_pos == 1 && ( !(selected in habitats) || (selected in habitats && habitats[selected].id == -3) ) ) {
				//if (true) {
					displaySetupHabitat(' Your current location 📍<br><br> Do you want to setup Habitat here? ', 2);
					//console.log(' yup! ');
					return;
				} else {
					//console.log(' need empty spot ' + habitats[selected].hab_id);
				}
			} else if ( !(selected in mebotee) ) {
				displaySetupHabitat(' Go to this location In Real Life (IRL) to setup a habitat there 📍 ', 1);
				console.log(' Go to this location IRL to setup habitat there. 📍 ');
			}
			console.log('center: ' + selected)
		}

		//if ( selected in mebotee && mebotee[selected].is_owner == 1) {
		if ( selected in mebotee ) {
			console.log('mebot here')

			//if (mebotee[selected].is_owner == 0) {
				viewMebot(selected)
				return;
			//}
			//return;
		}

		if (!scaling && selected >= 0 && selected in habitats) {

			if (habitats[selected].id == -1) {
				//pan_enabled = false;
				displayUndiscovered(habitats[selected].hid);
			} else if (habitats[selected].id == -2) {
				displayDarkMatter();
			} else if (habitats[selected].id == -3) {
				//do nothing
			} else {
				//pan_enabled = false;
				controller.abort();
				const map = document.getElementById('mapp');
				//hack done to remove the event listeners
				map.replaceWith(map.cloneNode(true));
				push('/habitat/2/' + habitats[selected].file_id)
			}

		}

		return;
		if (selected >= 0 && time_remaining > 0) {
			if (selected == 0) selected = 1;
			row = Math.floor(selected/game_row_size_active);
			target_tile = x_offset + (row+y_offset)*game_row_size + selected%game_row_size_active;
			//target_tile = selected + x_offset + y_offset*game_row_size;
			//console.log(target_tile)

			last_tap = current_tap;
			current_tap = selected;
			auto_assigned = false;

			if (steps_remaining <= 0) {
				displayRechargeMessage()
			}
			if (speed_factor <= 0) {
				displayZombieMessage()
			}
		}
	};

	//fetchLeaderboard();
	//fetchActiveMebots();
	//displayIntroMessage();
	progress.set(1)
	progress_factor.set(0.5)

	function update_tile(id) {
		let pos = id;
		let x = 0;
		let y = 0;
		landTiles[id].found = 1;

		for (x = -1; x <= 1; x++) {
			for (y = -1; y <= 1; y++) {
				pos = id + x + (y*game_row_size);
				if ( pos >= 0 && pos < game_size && landTiles[pos].found == 0 ) {
					landTiles[pos].found = 1;
				}
			}
		}
	}

	function calculate_next_dir(id) {

		if (target_tile == mebot_pos[id]) {

			//dir[id] = Math.floor(Math.random() * 4 + 1);
			//dirs[id] = [dir[id]];
			dirs[id] = [];
			auto_assigned = true;
			auto_targets = auto_targets.filter(item => item !== target_tile)
			//console.log('found target ' + target_tile)
			//console.log(auto_targets)
			target_tile = 0;

		} else {

			dirs[id] = [];
			last_mebot_dir[id] = 0;

			target_tile_x = target_tile%game_row_size;
			target_tile_y = Math.floor(target_tile/game_row_size);
			owner_x = mebot_pos[id]%game_row_size;
			owner_y = Math.floor(mebot_pos[id]/game_row_size);

			//(landTiles[next_mebot_pos[id]].s <= 0)
			if (target_tile_x > owner_x) {
				dirs[id] = [...dirs[id], 2]
			}
			if (target_tile_x < owner_x) {
				dirs[id] = [...dirs[id], 1]
			}
			if (target_tile_y > owner_y) {
				dirs[id] = [...dirs[id], 4]
			}
			if (target_tile_y < owner_y) {
				dirs[id] = [...dirs[id], 3]
			}
		}

		current_tap = -1;
	}

	function calculate_pos(id, dirs_local) {

		next_mebot_pos[id] = -1;
		for (const dir of dirs_local) {

			if (next_mebot_pos[id] == -1) {
				calculated_pos[id] = mebot_pos[id];
			} else {
				calculated_pos[id] = next_mebot_pos[id];
			}

			if (dir == 1 && mebot_pos[id] > 0 && last_mebot_dir[id] != 2) {
				if (mebot_pos[id] % game_row_size != 1) {
					if (mebots[id-1].is_owner == 1 && (mebot_pos[id]%game_row_size - x_offset) <= 2 && x_offset > 0) {
						x_offset = x_offset - 2;
					}
					next_mebot_pos[id] = calculated_pos[id] - 1;
				}
			}
			if (dir == 2 && last_mebot_dir[id] != 1) {
				if (mebot_pos[id] % game_row_size < game_row_size-2 && mebot_pos[id] < game_size-1) {
					if (mebots[id-1].is_owner == 1 && (mebot_pos[id]%game_row_size - x_offset) >= 5 && x_offset < game_row_size-game_row_size_active) {
						x_offset = x_offset + 2;
					}
					next_mebot_pos[id] = calculated_pos[id] + 1;
				}
			}
			if (dir == 3 && mebot_pos[id] > game_row_size*2 && last_mebot_dir[id] != 4) {
				if (mebots[id-1].is_owner == 1 && (Math.floor(mebot_pos[id]/game_row_size) - y_offset) <= 2 && y_offset > 0) {
					y_offset = y_offset - 2;
				}
				next_mebot_pos[id] = calculated_pos[id] - game_row_size;
			}
			if (dir == 4 && mebot_pos[id] < game_size-game_row_size*2 && last_mebot_dir[id] != 3) {
				if (mebots[id-1].is_owner == 1 && (Math.floor(mebot_pos[id]/game_row_size) - y_offset) >= 5 && y_offset < game_row_size-game_row_size_active) {
					y_offset = y_offset + 2;
				}
				next_mebot_pos[id] = calculated_pos[id] + game_row_size;
			}

			if (mebots[id-1].is_owner == 1) {
				steps_took++;
			} else {
				//avoid zombies 
			}
			mebots[id-1].steps_n++;
		}
	}

	function find_prize_dir(id) {
		let pos = mebot_pos[id];
		let start_pos = mebot_pos[id];
		let x = 0;
		let y = 0;
		let tmp_dirs = [];
		let found_sparkle = 0;
		let found_tile = 0;

		for (x = -1; x <= 1; x++) {
			for (y = -1; y <= 1; y++) {
				//if ((x == 0 || y == 0) && (x != 0 || y != 0)) {
				if (x != 0 || y != 0) {
					/*if (tmp_dirs.length == 2) {
						//console.log('found corner')
						console.log(dirs)
						continue;
					}*/
					if (found_sparkle == 1) {
						//console.log(tmp_dirs)
						continue;
					}
					pos = start_pos + x + (y*game_row_size);
					if ( found_sparkle == 0 && pos >= 0 && pos < game_size && landTiles[pos].s <= -1 && landTiles[pos].s >= -3 ) {
						found_sparkle = 1;
						if (x == 1 && !tmp_dirs.includes(2)) { tmp_dirs = [...tmp_dirs, 2] }
						if (x == -1 && !tmp_dirs.includes(1)) { tmp_dirs = [...tmp_dirs, 1] }
						if (y == 1 && !tmp_dirs.includes(4)) { tmp_dirs = [...tmp_dirs, 4] }
						if (y == -1 && !tmp_dirs.includes(3)) { tmp_dirs = [...tmp_dirs, 3] }
					}
					//if ( found_sparkle == 0 && pos >= 0 && pos < game_size && landTiles[pos].found == 0) {
					//	tmp_dirs = [];
					//	if (x == 1 && !tmp_dirs.includes(2)) { tmp_dirs = [...tmp_dirs, 2] }
					//	if (x == -1 && !tmp_dirs.includes(1)) { tmp_dirs = [...tmp_dirs, 1] }
					//	if (y == 1 && !tmp_dirs.includes(4)) { tmp_dirs = [...tmp_dirs, 4] }
					//	if (y == -1 && !tmp_dirs.includes(3)) { tmp_dirs = [...tmp_dirs, 3] }
					//	found_tile = 1;
					//	console.log('found file')
					//}
					//if not found try combing corners 
				}
			}
		}

		if (found_sparkle == 1 || found_tile == 1) dirs[id] = tmp_dirs;
	}

	async function mebot_walk(id) {

		if (mebots[id-1].is_owner == 1) {
			is_flashing = false;
			is_sparkle_flash = false;
		}

		last_mebot_pos[id] = mebot_pos[id];
		next_mebot_pos[id] = -1;
		if (mebots[id-1].is_owner == 1) {
			steps_took = 0;
			if (zombie_eaten > 0) zombie_eaten--;
		}
		//choose next direction

		if (landTiles[mebot_pos[id]].s == -1) {
			sparkle_count--;
			mebots[id-1].prize_n++;
			if (mebots[id-1].is_owner == 1) {

				prize_n = mebots[i-1].prize_n;
				is_sparkle_flash = true;
			}
		}

		//if (mebots[id-1].is_owner != 1 || isNaN(dirs[id])) {
			dirs[id] = [];
		//}
		dir[id] = Math.floor(Math.random() * 4 + 1);
		if (auto_roam == true || mebots[id-1].is_owner != 1) {
			dirs[id] = [dir[id]];
		}
		if (mebots[id-1].is_owner == 1 && target_tile == 0 && auto_roam) {
			if (auto_targets.length > 0) {
				target_tile = auto_targets[0]
				//console.log('NEW1 searching for:' + target_tile)
				//console.log(auto_targets)
				auto_assigned = true;
			} else {

				//find sparkle since everything else taken
				let found = -1;
				for (let i = 0; i < game_size; i++) {
					if (landTiles[i].s == -1)
						found = i;
				}
				if (found != -1 && autopilot_level > 3) {
					//console.log('found! ' + found)
					auto_targets = [found]
				}
			}
		}
		if (mebots[id-1].is_owner == 1 && target_tile > 0 && auto_roam && auto_assigned == true && !auto_targets.includes(target_tile)) {
			target_tile = 0;
			if (auto_targets.length > 0) {
				target_tile = auto_targets[0]
				//console.log('NEW2 searching for:' + target_tile)
				//console.log(auto_targets)
				auto_assigned = true;
			}
		}
		if (mebots[id-1].is_owner == 1 && target_tile > 0) {
			//console.log('searching for:' + target_tile)
			//owner only
			calculate_next_dir(id);
		}
		if (auto_roam == true || mebots[id-1].is_owner != 1) {
			//sniff out prizes
			find_prize_dir(id);
		}

		if (steps_remaining > 0 || mebots[id-1].is_owner != 1) {
			calculate_pos(id, dirs[id])
			//check single directions if the two directions are not working
			if (mebots[id-1].is_owner == 1 && dirs[id].length == 2 && next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s > 0 || landTiles[next_mebot_pos[id]].s == -4)) {
				calculate_pos(id, [dirs[id][0]])
			}
			if (mebots[id-1].is_owner == 1 && dirs[id].length == 2 && next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s > 0 || landTiles[next_mebot_pos[id]].s == -4)) {
				calculate_pos(id, [dirs[id][1]])
			}
		}

		//if (dir[id] == 5) {
		//}

		//check if tile is empty
		//if (last_mebot_pos[id] != mebot_pos[id] && landTiles[mebot_pos[id]].s == 0) {
		//if (last_mebot_pos[id] != mebot_pos[id]) {
		//if (next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s <= 0 || mebots[id-1].is_owner == 1)) {

		//avoid zombies  if (Math.floor(Math.random() * 60 + 1) == 2) {
//		if (mebots[id-1].is_owner != 1 && next_mebot_pos[id] >= 0 && landTiles[next_mebot_pos[id]].s == -4) {
		if (next_mebot_pos[id] >= 0 && landTiles[next_mebot_pos[id]].s == -4 && (mebots[id-1].is_owner != 1 || Math.floor(Math.random() * 4 + 1) > (5 - autopilot_level) && auto_roam)) {
			next_mebot_pos[id] = -1;
		}

		if (next_mebot_pos[id] >= 0 && (landTiles[next_mebot_pos[id]].s <= 0)) {
			if (landTiles[next_mebot_pos[id]].s == -1) {
				sparkle_count--;
				mebots[id-1].prize_n++;
				if (mebots[id-1].is_owner == 1 && speed_factor > 0) {
					prize_n = mebots[id-1].prize_n
					is_sparkle_flash = true;

					if (steps_remaining > 0 && speed_factor > 0) {
						progress_n += 25;
						if (progress_n > 100) progress_n = 100;
						progress.set(progress_n/100)
					}

					//audio.play();
				}
			}
			if (landTiles[next_mebot_pos[id]].s == -2) {
				if (mebots[id-1].is_owner == 1) {
					speed_factor = speed_factor + 7;

					if (steps_remaining > 0 && speed_factor > 0) {
						progress_n += 35;
						if (progress_n > 100) progress_n = 100;
						progress.set(progress_n/100)
					}

					if (speed_factor > 200) speed_factor = 200;
					is_flashing = true;

					setSpeed()
					//boost_left = 140;
					//delay = 100;


					//boost_audio.play();
				} else {
					boosts_left[id] = 140;
				}
			}
			if (landTiles[next_mebot_pos[id]].s == -3) {
				if (mebots[id-1].is_owner == 1) {
					play_time = play_time + 15;
					extra_time = Math.floor(Date.now() / 1000);
				}
			}
			if (mebots[id-1].is_owner == 1 && speed_factor > 0) {

				if (landTiles[next_mebot_pos[id]].s == -4) {
				speed_factor = speed_factor - 30;
				zombie_eaten = 2;

				progress_n = progress_n - Math.floor( progress_n * .3 )
				progress.set(progress_n/100)

				is_flashing = true;
				setSpeed();
				if (speed_factor < 0) { 
					displayZombieMessage()
					landTiles[last_mebot_pos[id]].s = 0;
					landTiles[next_mebot_pos[id]].s = id;
					speed_factor = 0;
					update_tile(next_mebot_pos[id]);

					cur_time = Math.floor(Date.now() / 1000);
					time_remaining = play_time - cur_time + start_time;
					if (time_remaining > 3) {
						play_time = 3 + cur_time - start_time;
					}
					progress.set(0)
				}
				}

				if (landTiles[next_mebot_pos[id]].s == -6) {
					displayFoundEgg()
					landTiles[last_mebot_pos[id]].s = 0;
					landTiles[next_mebot_pos[id]].s = id;
					cur_time = Math.floor(Date.now() / 1000);
					time_remaining = play_time - cur_time + start_time;
					if (time_remaining > 1) {
						play_time = 1 + cur_time - start_time;
					}
				}
			}
			if (steps_remaining > 0 && speed_factor > 0 && mebots[id-1].is_owner == 1) {
				steps_took = steps_took;
				steps_remaining = steps_remaining - steps_took;
				if (steps_remaining < 0) steps_remaining = 0;
				steps_taken += steps_took
				if (steps_remaining == 0) {

					cur_time = Math.floor(Date.now() / 1000);
					time_remaining = play_time - cur_time + start_time;
					if (time_remaining > 5) {
						play_time = 5 + cur_time - start_time;
					}
					progress.set(0)
					displayRechargeMessage()
					//if (time_remaining > 7) {
					//	time_remaining = 7;
					//}
					saveGame()
				}
			}
			if ((steps_remaining > 0 && speed_factor > 0) || mebots[id-1].is_owner != 1) {
				if (mebots[id-1].is_owner != 1 && landTiles[next_mebot_pos[id]].s > -5
				  || mebots[id-1].is_owner == 1 && landTiles[next_mebot_pos[id]].s != -5) {
				landTiles[last_mebot_pos[id]].s = 0;
				landTiles[next_mebot_pos[id]].s = id;
				mebot_pos[id] = next_mebot_pos[id];
				last_mebot_dir[id] = dir[id];
				auto_targets = auto_targets.filter(item => item !== next_mebot_pos[id])
				update_tile(next_mebot_pos[id]);
				}
			}
		}
		last_mebot_dir[id] = dir[id];

		//{
		//	mebot_pos[id] = last_mebot_pos[id];
		//}

		//await sleep(Math.floor(Math.random() * 600 + 100));
		if (id > 0 && mebots[id - 1].is_owner == 1) {
			//delay = 300;
			//console.log(delay)
			//await sleep(Math.floor(Math.random() * delay + (delay-50)));
			if (boost_left > 0) {
				boost_left--;
			}
			if (boost_left == 0) {
				delay = _default_delay
			}
			await sleep(delay);
		} else {
			//if (false) {
			if (boosts_left[id] > 0) {
				boosts_left[id]--;
				await sleep(100);
			} else {
				//await sleep(Math.floor(Math.random() * 1000 + 500));
				//console.log('delay ' + mebots[id - 1].watts)
				//Math.floor(Math.random() * (max - min + 1)) + min;
				//min: 300 -  mebots[id - 1].speed_factor
				//max: 600 -  mebots[id - 1].speed_factor
				//await Math.floor(Math.random() * (600 -  mebots[id - 1].speed_factor - 300 -  mebots[id - 1].speed_factor + 1)) + 300 -  mebots[id - 1].speed_factor;
				await sleep(Math.floor(Math.random() * (700-mebots[id - 1].speed_factor) + 300 - mebots[id - 1].speed_factor));
				//console.log(Math.floor(Math.random() * (700-mebots[id - 1].speed_factor) + 300 - mebots[id - 1].speed_factor))
				//console.log((700-mebots[id - 1].speed_factor))
			}
		}

		update_board()
		if (time_remaining <= 0) {
			current_tap = -1;

			if (mebots[id-1].is_owner == 1) {
				//if Zombies got our mebot remove his prizes
				if (speed_factor <= 0) {
					mebots[id-1].prize_n = -1;
					//prize_n = 0;
				}
				mebots.sort((a, b) => b.prize_n - a.prize_n);
				await saveGame();
				await sleep(310);
				setWinners();
			}
			return;
		}
		//landTilesFinal = landTiles.slice(x_offset, x_offset + game_size_active);
		if (mebots[id-1].is_owner == 1) {
			cur_time = Math.floor(Date.now() / 1000);
			time_remaining = play_time - cur_time + start_time;
			if (time_remaining > play_time) time_remaining = play_time;
			if (time_remaining < 0) time_remaining = 0;
			//console.log(cur_time);

			if (time_remaining > 0 && speed_factor > 0) {
				progress_n = progress_n - Math.floor( progress_n * .08 )
				if (progress_n < 0) progress_n = 0;
				progress.set(progress_n/100)
			}

			if ((Date.now()%10 == 0) && speed_factor > watts_calc) {
				speed_factor = speed_factor - Math.floor(speed_factor * .02)
				if (speed_factor < watts_calc) {
					speed_factor = watts_calc;
				}
			}
		}

		if (mebots[id-1].is_owner == 1 && sparkle_count <= 0) {
			await reloadBoard();
			update_tile(mebot_pos[owner_id+1])
		}
		mebot_walk(id);
	}

	onMount(async () => {
		//console.log("mount");
		//return () => console.log("unmount"); // not called
	});
	onDestroy(() => {
		//console.log("test");
	});

	function zeroPad(num, places) {
		var zero = places - num.toString().length + 1;
  		return Array(+(zero > 0 && zero)).join("0") + num;
	}

	function numberWithCommas(x) {
    	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	let charged = Math.random() * 0.0025 + 0.0005;
	charged = 0.0008;
	const SPRING_IN = { stiffness: charged, damping: 0.014 };
	const animateIn1 = (node) => {
		const { duration, tickToValue } = springIn(-9, 0, SPRING_IN);
		return {
			duration: 1000,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};
	const animateIn2 = (node) => {
		const { duration, tickToValue } = springIn(-8, 0, { stiffness: charged, damping: 0.014 });
		return {
			duration: 1200,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};
	const animateIn3 = (node) => {
		const { duration, tickToValue } = springIn(-8, 0, { stiffness: charged, damping: 0.014 });
		return {
			duration: 800,
			css: (t) => `transform: translateY(${tickToValue(t)}px)`,
		};
	};

	/*
	function decrementTimer() {
		if (time_remaining > 0) {
			time_remaining--;
		}
	}

	var intervalId = window.setInterval(function(){
		decrementTimer();
	}, 1000);
	*/

	async function activateMebot(m_id) {
		const res = await fetch(
			"https://api.forever.today/?method=activate_mebot",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id: m_id
				}),
			}
		);

		mebot_id = m_id;
		const json = await res.json();
	}

	async function switchMebot(i) {
		console.log(i)

		mebots_loading = true;
		content_loading.update(n => true);
		if (i >= 0 && i in mebots) {
			//console.log(mebots[i].is_active)

			await activateMebot(mebots[i].id);
			await doPost();
			await fetchMapHabitats();
			zoomMap(0);

			replace('/go/2/map/0_' + mebots[i].id);
			//#/map/2/1/0_59
			show_mebots = false;
			//doPost();
			//getMyMebots();
		}

		if (i == -1) {
			replace("/go/2/map");
		}
		content_loading.update(n => false);
		mebots_loading = false;

	}

	async function showMebots() {

		show_mebots = !show_mebots;
		map_menu = false;
		open_modes_menu = false;

		if (show_mebots) {
			//refresh
			await getMyMebots();
		}

		if (mebots.length > 1) {
		} else {
		}

	}

	async function getMyMebots() {

		mebots_loading = true;
		content_loading.update(n => true);

		let res = await fetch(
			"https://api.forever.today/?method=get_mebots",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
				}),
			}
		);

		let json = await res.json();
		let runners = json.data.mebots;
		let ii = 0;

		let mebots_tmp = [];
		for (const runner of runners) {
			if (runner.md.is_hatched == 1 || runner.m_id > 10000) {
				mebots_tmp.push({
					id: runner.m_id,
					img: runner.mebot_img_url,
					is_hatched: runner.md.is_hatched,
					chain_id: runner.md.chain_id,
					mtype: runner.md.mtype,
					is_hatching: runner.md.is_hatching,
					is_active: runner.md.is_active,
					minted: runner.md.minted,
					hatched: runner.md.hatched,
					watt_level: runner.md.watt_level,
					autopilot_level: runner.md.autopilot_level,
					trips: runner.md.trips,
					auto_walk: runner.md.auto_walk,
					byline: runner.md.byline,
					extra: runner.md.extra,
					badges: runner.md.badges,
					n_items: runner.md.n_items,
					hs: runner.md.hs,
				});
				ii++;
			}
		}
		mebots = mebots_tmp;

		mebots_loading = false;
		content_loading.update(n => false);

	}

	async function doPost() {

		const res = await fetch(
			"https://api.forever.today/?method=get_dash_user",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token
				}),
			}
		);

		const json = await res.json();
		my_mebot_img_url = json.data.mebot_img_url;
		setCookie("mebot_img_url", my_mebot_img_url, 30);
		setCookie("m_id", mebot_id, 30);
	}

	getMyMebots();

	let x = 800 // the value returned by getX() function
	let article_n = 0; // number of items that load on the page initially

	const loadOnMebotScroll = (elem) => {
		//console.log('scrollTop: ' + elem.scrollTop + ' scrollHeight: ' + elem.scrollHeight);
		if (elem.scrollTop >= (elem.scrollHeight - x) ) {
			return;
			if (artifact_fetching == false) {
				//article_n += artifact_page_size;
				//getArtifacts(article_n);
				//console.log('article_n: ' + article_n);
			}
		}
	}

	const loadOnMapMenuScroll = (elem) => {
	}

</script>

<Header header_mebot_id={mebot_id} header_dash_token={dash_token} mebot_url={my_mebot_img_url} news_badge_n={news_badge_n} />

<center>
	<table width=330px height=10px border=0>
	<tr>
	<td width=150px valign=middle style="white-space:nowra;" align="left">
		{#if false }
		<button style="width: 60px;" class="menu_btn_help menu_btn_miami" class:menu_active={ map_filter == 3 ||  map_filter == 4 } on:click={() => fetchMapFilter(3)}>
			<span class="leaderboard" >
				<!-- 🌴 -->
				<span style="display: flex; align-items:center; justify-content: center;" >
					&nbsp;<img src="https://steps.forever.today/images/a19b58229eaddeb403fc0c81b4b84922.png" style="padding-top: 2px; padding-left: 2px;" width=18px height=18px alt=''>&nbsp; { !isNaN(city_stats.mp) ? city_stats.mp : '00' }% &nbsp;
				</span>
			</span>
		</button>
		<button class="menu_btn_home_invisible" on:click={() => fetchMapFilter(3)}>
			<!-- vs -->
			<span style="display: flex; align-items:bottom; justify-content: bottom;" >
				<img src="https://steps.forever.today/images/7808ba0cfbe0ec15320a80d73d88218e-svg.png" style="margin-top: 0px; padding-left: 0px;" width=12px height=12px alt=''>
			</span>
			<!--<button class="menu_btn_home_invisible"> <span class="text-electric"> <i>vs</i> </span> </button>-->
		</button>
		<button style="width: 60px;" class="menu_btn_help menu_btn_nyc" class:menu_active={ map_filter == 3 ||  map_filter == 4 } on:click={() => fetchMapFilter(4)}>
			<span class="leaderboard" >
				<!-- 🗽 -->
				<span style="display: flex; align-items:center; justify-content: center;" >
					&nbsp;<img src="https://steps.forever.today/images/19a73a292153913e0a471eb0a179b96a.png" style="padding-top: 2px; padding-left: 2px;" width=18px height=18px alt=''>&nbsp; { !isNaN(city_stats.np) ? city_stats.np : '00' }% &nbsp;
				</span>
			</span>
		</button>
		{:else}

		<span style="display: flex; flex-wrap: wrap;">

		{#if has_loaded }
		{#if cur_guild != '' }
			<button class="menu_btn_clear2 info-sm" style="position: relative;" on:click={() => showCityGuilds()}>
			<span class="leaderboard" >
				<span class="text-electric-white info-sm" style="white-space: nowra;" >
					&nbsp; { cur_guild } &nbsp;
				</span>
			</span>
			</button>
		{:else}

		<img src="https://app.mebots.xyz/img/compass-2-500.png" width="30px" height="30px" alt='north' on:click={() => showNorth()}> 
		&nbsp;&nbsp;
		<button class="menu_btn_help menu_btn_clear" style="position: relative;" on:click={() => showCityControl()}>
			<span class="leaderboard" >
				&nbsp; <span class="text-electric"> 👑 </span> &nbsp;
			</span>
			{#if cities_n > 0 }
			<span class="cities__badge">{ cities_n }</span>
			{/if}
		</button>
		&nbsp;&nbsp;
		<button class="menu_btn_help menu_btn_clear" style="position: relative;" on:click={() => showCityGuilds()}>
			<span class="leaderboard" >
				&nbsp; <span class="text-electric"> 🛡️ </span> &nbsp;
			</span>
			{#if guilds_n > 0 }
			<span class="cities__badge">{ guilds_n }</span>
			{/if}
		</button>
		{/if}
		{/if}

		</span>
		{/if}

<!--	<span>
		<span class="text-electric info" class:info-pulsing={ time_remaining > 0 && time_remaining <= 10 }>
			{Math.floor(time_remaining/60) < 10 ? '0' : ''}{ Math.floor(time_remaining/60) }:{ time_remaining < 10 ? '0' + time_remaining : (time_remaining > 59 ? ( (time_remaining % 60) < 10 ? '0' + (time_remaining % 60) : (time_remaining % 60)) : time_remaining) }
		</span>
		{#if (play_time > original_play_time && time_remaining > 0 && extra_time > cur_time-1) }
		&nbsp;<span class="text-electric-white info-time-pulsin" > ⏳</span>
		{:else if (boost_left > 0 && time_remaining > 0) }
		&nbsp;&nbsp;<span class="text-electric-white info-extra info-time-pulsing" style="white-space: nowrap;">⚡ boosted!</span>
		{:else}
		&nbsp;<span on:click={endGameEarly} class="text-electric-whit info-time-pulsin" > 🛑</span>
		{/if}

	</span>-->
	</td>
	<td width=40px align=center> <span class="text-electric" style="font-size: 10px; color: white;">{@html res_desc }</span> </td>
	<td width=140px style="white-space:nowrap;" align=right>
		<!--<button class="menu_btn_help menu_btn_controlled" class:menu_active={ map_filter == 2 } on:click={() => fetchMapFilter(2)}>
			<span class="leaderboard" >
				&nbsp; <span class="text-electric"> &nbsp; </span> &nbsp;
			</span>
		</button>
		&nbsp;-->

		{#if cur_guild_stats != '' }
		<button class="menu_btn_clear2" on:click={() => onGetAppAction()}>
			<span class="leaderboard" >
				&nbsp; <span class="text-electric" style="font-size: 12px;" >{@html cur_guild_stats }</span> &nbsp;
			</span>
		</button>
		&nbsp;
		<button class="menu_btn_help claim_active" on:click={() => onGetAppAction()}>
			<span class="leaderboard">
				&nbsp; <span class="text-electric">Join</span> &nbsp;
			</span>
		</button>
		{:else}

		<!--
		<button class="menu_btn_help menu_btn_visited" class:menu_active={ map_filter == 1 } on:click={() => fetchMapFilter(1)}>
			<span class="leaderboard" >
				&nbsp; <span class="text-electric"> &nbsp; </span> &nbsp;
			</span>
		</button>
		&nbsp;
		<button class="menu_btn_help menu_btn_clear" class:menu_active={ map_filter == 5 } on:click={() => fetchMapFilter(5)}>
			<span class="leaderboard" >
				&nbsp; <span class="text-electric"> &nbsp; </span> &nbsp;
			</span>
		</button>
		&nbsp;-->

		{#if mebot_id > 0 }

		<button class="menu_btn_help menu_mebots_state_active" class:menu_mebots_state_active_active={ (open_modes_menu) } style="position: relative;" on:click={() => changeMode() }>
			<span class="leaderboard" >
				&nbsp; <span class="text-electric"> 🎛️ </span> &nbsp;
			</span>
			{#if journey['n_items'] > 0 }
				<span class="energy_items__badge">{ journey['n_items'] }</span>
			{/if}
		</button>

		<button class="menu_btn_help" on:click={() => fetchHelp()}>
			<span class="leaderboard">
				&nbsp; <span class="text-electric">?</span> &nbsp;
			</span>
		</button>

		<button class="menu_btn_mebots" class:menu_mebots_mode_active={ (show_mebots) } class:menu_mebots={ (!show_mebots) } style="position: relative;" on:click={showMebots}>
			<span style="letter-spacing: -em">&nbsp;⋮⋮⋮&nbsp;</span>
			{#if mebots.length > 1 }
			<span class="mebots__badge">{ mebots.length }</span>
			{/if}
		</button>

		{/if}

		{/if}
	</td>
	</tr>
	<!--<tr>
		<td width=110px valign=middle></td>
		<td width=100px><div class="outer"><div class="progress_inner" style="width: {$progress * 100}%"></div></div></td>
		<td width=90px valign=middle></td>
	</tr>-->
	</table>
</center>
<div style="position: relative; width: 340px; margin-left: auto; margin-right: auto;">
	{#if map_menu }
	<div class="main1-square" on:scroll="{ () => loadOnMapMenuScroll(document.querySelector('.main1-square')) }">
		<div style="height: 16px;"></div>
		<span on:click={ () => ( map_menu = false ) } style="position: absolute; top: 0px; right: 0px; z-index: 10001;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

		{#if ents_xy > -1 }
		<div class="snake_row">

			{#each entities[ents_xy] as tittie, i}
			<div class="mebots-flip-box">
			<div class="flip-box-inner">
			<div class="m-flip-box-front card" >
				<div class="vertical-center" on:click={ () => viewEnt(i) }>
						<div class="message question" transition:fade|local={{duration: 300}}>
							<img data-card-id={i} src="{tittie.url}" width=70px height=70px alt="mebot" 
								class:card-active-owner-menu1={ (tittie.io == 1) }
								class:card-active-non-owner-menu1={ (tittie.io == 0) }
								class:card-active-active-owner={ (tittie.id == mebot_id) }
								style="border-radius: 10px;">
							{#if tittie.em != '' }
								<span data-card-id={i} class="habitat__map_menu_artifact"> { tittie.em } </span>
							{/if}
							<div data-card-id={i} class="mebot-byline text-glow-blueish" style="height: 20px;">
								{@html tittie.e }
							</div>
						</div>
				</div>
			</div>
			</div>
			</div>
			{/each}

		</div>
		{/if}

	</div>
	{/if}

	{#if open_modes_menu }
	<div class="main1-square">
		<div style="height: 16px;"></div>

		<span on:click={ () => ( open_modes_menu = false ) } style="position: absolute; top: 0px; right: 0px; z-index: 10001;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

		<div>
		<center>
			<br>
			<div class="text-electric" style="font-size: 16px;"> Command Center </div>
			<br>
		<img on:click={ () => replace('/go/2/map/0_' + mebot_id) }
			src="{mebot_url}" width=80 height=80 alt='Mebot' class="text-electric-location1" style="border-radius: 10px;"><br>
			{@html journey['distance'] }
		</center>
		</div>

		<div class="snake_row">

			{#each modes as state, i}
			<div class="modes-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => changeMode( (
					(state.is_state_on == 0 && state.group_id == 1) || 
					(state.is_mode_on == 0 && state.group_id == 2)
				) ? state.cmd_id : 0 ) }>
						<div class="message question" >
							<button data-card-id={i} class="menu_btn_mebots_rounded" 
							class:menu_mebots_state_active={ state.is_state_on == 0 && state.group_id == 1 } 
							class:menu_mebots_mode_active={ state.is_mode_on == 0 && state.group_id == 2 } 
							style="margin-top: 4px; width: 78px; height: 55px; white-space: nowrap; font-size: 12px;">
							{#if state.is_state_on == 1 || state.is_mode_on == 1 }
								{@html state.name_active }
							{:else}
								{@html state.name }
							{/if}
							</button>
						</div>
				</div>
			</div>
			</div>
			</div>
			{/each}

		</div>

		{#if modes.length > 0 }

		<center>

		{#if journey['info'] != '' }
		<div class="text-electric" style="margin-top: 12px; margin-bottom: 0px;" >
		{@html journey['info'] }
		</div>
		{/if}

		{#if (journey['chat_cmd_id'] != '' || just_collected) }

		{#if (journey['visited'] != '') }
			<div class="text-electric-white-clock" style="margin-top: 10px;">
			{@html journey['visited'] }
			</div>
		{:else}
			<div class="text-electric-collected-grad" style="margin-top: 10px;">
			{@html just_collected_visted }
			</div>
		{/if}

		<div class="snake_row">

			<div class="energy-collect-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => (journey['n_items'] > 0 ? sendCmd(journey['chat_cmd_id']) : '') }>

					<div class="message question" >
						<button class="menu_btn_mebots_rounded" class:menu_mebots_energy_active={ journey['n_items'] > 0 }
						style="margin-top: 4px; width: 130px; height: 55px; white-space: nowrap; font-size: 12px;">

						{#if !(2 in is_loadings) || is_loadings[2] == false }

						{#if journey['n_items'] > 0 }
							Collect { journey['n_items'] } item{ (journey['n_items'] > 1) ? 's' : '' } ✔️
						{:else}
							<span class="text-electric-collected-grad">Items collected!</span>
						{/if}

						{:else}
						<span class="level_pulsing text-electric-white-clock" ><b>....</b> </span>
						{/if}

						</button>
					</div>

				</div>
			</div>
			</div>
			</div>
		</div>

		{:else}
		<br>
		{/if}

		<table border=0><tr><td width=110px>
			<div style="width: 110px; align: left; margin-top: 2px;">
				{#if ($power_avail >= 0) }
					<div class="outer_daily_power">
						<div class="progress_inner_daily_power" style="width: {$power_avail * 100}%; margin-top: 4px; margin-bottom: 5px;" ></div>
					</div>
				{/if}
				</div>
		</td></tr></table>

		<div class="text-green" style="margin-top: 4px; font-size: 12px;">
			<span style="color: white;"> Power available:</span> { mebot_md.power_avail }
		</div>
		</center>

		<div class="snake_row">

			<div class="energy-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => (mebot_md.power_bank != 0 ? sendCmd(4) : '') }>

					<div class="message question" >
						<button class="menu_btn_mebots_rounded" class:menu_mebots_energy_active={ mebot_md.power_bank != 0 }
						style="margin-top: 4px; width: 90px; height: 55px; white-space: nowrap; font-size: 12px;">
						{#if !(4 in is_loadings) || is_loadings[4] == false }
						⬆️ Restore<br>
						energy
						{:else}
						<span class="level_pulsing"><b>....</b><br> </span>
						{/if}
						</button>
					</div>

				</div>
			</div>
			</div>
			</div>

			<div class="energy-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => (mebot_md.power_avail > 0 ? sendCmd(3) : '') }>

					<div class="message question" >
						<button class="menu_btn_mebots_rounded" class:menu_mebots_energy_active={ mebot_md.power_avail > 0 } 
						style="margin-top: 4px; width: 90px; height: 55px; white-space: nowrap; font-size: 12px;">
						{#if !(3 in is_loadings) || is_loadings[3] == false }
						Store ⬇️ <br>energy 
						{:else}
						<span class="level_pulsing"><b>....</b><br> </span>
						{/if}
						</button>
					</div>

				</div>
			</div>
			</div>
			</div>
		</div>

		<center>
		<div class="text-green" style="margin-top: 10px; font-size: 12px;">
			<span style="color: white;">🔋 Power bank:</span> 
			{#if ( (3 in is_loadings && is_loadings[3] == true) || (4 in is_loadings && is_loadings[4] == true) ) }
				<span class="level_pulsing1">{ mebot_md.power_bank }</span>
			{:else}
				{ mebot_md.power_bank }
			{/if}
		</div>
		</center>

		<br><br>

		{/if}

		{#if modes.length == 0 }
		<div class="loader" use:loader={content_loading}><br><br></div>
		{/if}
	</div>
	{/if}

	{#if show_mebots }
	<div class="main1" on:scroll="{ () => loadOnMebotScroll(document.querySelector('.main1')) }">
		<div style="height: 16px;"></div>

		{#if !mebots_loading }

		<span on:click={ () => ( show_mebots = false ) } style="position: absolute; top: 0px; right: 0px; z-index: 10001;">
			<img src="https://app.mebots.xyz/img/close-btn-500-white.png" style="border-radius: 10px; margin: 14px;" alt="close" width="20px" height="20px">
		</span>

		<div class="snake_row">

			<div class="mebots-flip-box" >
				<div class="flip-box-inner">
				<div class="m-flip-box-front card">
					<div class="vertical-center" on:click={ () => switchMebot(-1) }>
							<div class="message question" transition:fade|local={{duration: 300}}>
								<img src="https://app.mebots.xyz/img/your_loc_400.png" width=70px height=70px alt="mebot" style="border-radius: 10px;">
								<div class="mebot-byline text-glow-blueish">
									Your current<br>
									location 📍
								</div>
								<!--<button style="width: 36px;" class="menu_btn_home menu_btn_home_inactive menu_btn_center" class:live_pulsing_bg={ show_is_live }>
									<span class:live_pulsing={ show_is_live } class="text-electric" > ⊚ </span>
								</button>-->
								<!--<div data-card-id={i} class="mebot-byline-small text-glow-blueish">
									{#if mebot.badges != null}
										{@html mebot.badges }
									{/if}
								</div>-->
							</div>
							<!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
					</div>
				</div>
				</div>
			</div>

			{#each mebots as mebot, i}
			<div class="mebots-flip-box" >
			<div class="flip-box-inner">
			<div class="m-flip-box-front card">
				<div class="vertical-center" on:click={ () => switchMebot(i) }>
						<div class="message question" transition:fade|local={{duration: 300}} >
							<img data-card-id={i} src="{mebot.img}"
							style=" { ( mebot.hs != '' && mebot.id != mebot_id) ? 'border-radius: 10px; background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url( ' + mebot.hs + '); background-size: cover;' : 'border-radius: 10px;' } "
							class:text-electric-location1={ mebot.id == mebot_id } width=70px height=70px alt="mebot" >
							<div data-card-id={i} class="mebot-byline text-glow-blueish">
								<!--{@html mebot.byline }-->
								{@html mebot.extra }
							</div>
							<!--<div data-card-id={i} class="mebot-byline-small text-glow-blueish">
							{#if mebot.badges != null}
								{@html mebot.badges }
							{/if}
							</div>-->

							{#if mebot.n_items > 0 }
								<span class="energy_items__badge">{ mebot.n_items }</span>
							{/if}

						</div>
						<!--<div class="message question " data-card-id={i} > <img src="{mebots[s-1].img}" width=36px alt="mebot"></div>-->
				</div>
			</div>
			</div>
			</div>
			{/each}

		</div>
		{/if}

		<div class="loader" use:loader={content_loading}><br><br></div>

	</div>
	{/if}

</div>
<center>
	<!--<a href="/#/supersnake/{dash_token}/{mebot_id}">-->
	{#if (time_remaining > 0 && is_rebuilding == 0) }

		<div id="mapp" class="snake_row" out:fade|local={{duration: 300}} in:fade|local={{duration: 300}} style="user-select: none; ">
			{#each landTilesFinal as { name, watt_level, watts, img, text, s, found, b}, i}
				<div class="flip-box"  style="user-select: none;">
					<div class="flip-box-inner"  style="user-select: none; ">
						<div class="flip-box-front flip-box-front1 card { b > 0 ? flip_box_border : '' } { found == 0 ? flip_box_front : '' }"
 							 class:menu_btn_center={ found > 0 && i == (cpos) && i != 40 && (!(i in habitats) || habitats[i].id == -1 || habitats[i].id == -3)}
							 class:live_pulsing_bg={ found > 0 && i == (cpos) && i != 40 && (!(i in habitats) || habitats[i].id == -1 || habitats[i].id == -3)}
							 style=" { (i != 40 && i != (cpos) && i in habitats && (habitats[i].m == 0 || habitats[i].v == 1)) ? 'background-color: ' + habitats[i].bg + ';' : ''} "
							 class:mayor-background={ s == -1 && i in habitats && habitats[i].m == 1 && habitats[i].v == 0}
							 class:visited-background={ s == -1 && i in habitats && habitats[i].v == 1 }
							 class:dark-matter={ s == -1 && i in habitats && habitats[i].ether == 1 }
							 class:undis-background={ s == -1 && i in habitats && habitats[i].undis == 1 && habitats[i].v == 0}
							 class:card-active={( i in mebotee ? 1 : 0) || i == current_tap}
							 class:card-active-owner={( i in mebotee ? mebotee[i].is_owner == 1 : 0) || i == current_tap}
							 class:card-active-active-owner={ (i in mebotee ? mebotee[i].id == mebot_id : 0) }
							 class:card-active-pulse={( i in mebotee ? (auto_roam) : 0)}
							 class:card-miami={( i in mebotee ? (mebotee[i].team_miami == 1) : 0)}
							 class:card-fairy={( i in mebotee ? (mebotee[i].team_nyc == 1) : 0)}
							 class:text-electric-location1|local={ found > 0 && i == (40) && (i in habitats && habitats[i].id > 0) }
							 class:text-electric-location2|local={ found > 0 && i == (40) && (!(i in habitats) || habitats[i].id == -1 || habitats[i].id == -3)}
							 >
							<div
								class="vertical-center"
								on:click={toggleBackFront}>
								<!-- use:longpress on:longpress={toggleBackFront} -->

							{#if i in mebotee }

							<!-- zombie -->
							{#if mebotee[i].type == 1 }

							<div style="width: 22px; height: 22px;"> <span data-card-id={i} class="vertical-center1 text-electric-zombie" style="width: 20px; height: 20px; ">🧚</span> </div>

							{:else if  mebotee[i].type == 2 }

							<div style="width: 22px; height: 22px;"> <span data-card-id={i} class="vertical-center1 " style="width: 20px; height: 20px; ">🥷</span> </div>

							{:else if  mebotee[i].type == 3 }

							<div style="width: 22px; height: 22px;"> <span data-card-id={i} class="vertical-center1 " style="width: 20px; height: 20px; ">🧞</span> </div>

							{:else}
							<div
								class="mebot_player"
							>

							<!-- special case for artifcats: show arts instead of mebots -->
							{#if  !(i in habitats) || ((i in habitats) && habitats[i].em != '🚩') }
								<img
									class:info-pulsing={ ( (i in mebotee ? mebotee[i].id != mebot_id : 0) ) }
									class:text-electric-location2={ (i in mebotee ? mebotee[i].id == mebot_id : 0) }
									class:info-pulsing-zombie1={ ( mebotee[i].is_owner == 1 && zombie_eaten > 0) }
									src={mebotee[i].img}
									width="36px"
									alt="mebot"
									data-card-id={i}
								/>
							{/if}

							</div>
								{#if mebotee[i].badge != '' && mebotee[i].badge > 1 }
									<span data-card-id={i} class="habitat__badge_mebot"> {@html mebotee[i].badge } </span>
								{/if}
							{/if}

							<!--<div class="message question " data-card-id={i} > <img src="{mebotee[s-1].img}" width=36px alt="mebot"></div>-->
							{/if}

								{#if s == 0 || s == -1 && found == 0 && !(i in mebotee)}
								<div data-card-id={i} style="width: 40px; height: 40px;"> </div>
								{/if}

<!-- {#if s == -1 && found > 0 && !(i in mebotee)} -->
<!-- special case for artifcats: show arts instead of mebots -->
{#if s == -1 && found > 0 && ( !(i in mebotee) || ( (i in habitats) && habitats[i].em == '🚩' ) ) }
{#if i in habitats }

<!--								<div ><img data-card-id={i} src={large_sparkle_img} width=32px alt="mebot"></div>-->
<!--									<div style="width: 30px; height: 30px;"> <div data-card-id={i} class="vertical-center1 text-electric-white" style="display: block; width: 30px; height: 30px;">✨</div> </div>-->

<!--									<div style="width: 40px; height: 40px;"> <span class="text-electric-white"><img data-card-id={i}  src={sparkle_img} width=40px; alt=''></span> </div>
-->
{#if habitats[i].ether == 0 }
<div style="width: 30px; height: 34px; position: relative;" >
	<span class="text-electric-white " style="" >
		<img data-card-id={i}  src={ habitats[i].url } width=30px height=34px class:darken={ habitats[i].em != '' } style="border-radius: 3px;" alt=''>
	</span>
	{#if (habitats[i].gem_n > 0) }
		<span><span data-card-id={i} class="habitat__badge_se2"> { habitats[i].gem_n } </span></span>
	{/if}
	{#if (habitats[i].em != '') }
		<span><span data-card-id={i} class="habitat__badge_gem_shine_artifact"> { habitats[i].em } </span></span>
	{/if}
	{#if embark['em'] == '' && i == (cpos) && habitats[i].em == '' && is_anon == 0 }
		<span data-card-id={i} class="ego">
			<img data-card-id={i}  src={ mebot_img_url } width=30px height=30px alt=''>
		</span>
	{/if}
</div>
{:else}

{#if i == (40) && i != (cpos) }
<div style="width: 30px; height: 34px;"> <span class="text-electric-white"><img data-card-id={i} src="https://app.mebots.xyz/img/map-center-500.png" width=30px height=34px style="border-radius: 3px;" alt=''></span> </div>
<!--<div style="width: 22px; height: 22px;"  >
	<div data-card-id={i} style="padding-left: 4px; padding-right: 4px; margin-bottom: 10px; color: white;">⊚</div>
</div>-->
<!--<div style="width: 40px; height: 40px;"> <span class="text-electric-white"><img data-card-id={i}  src={sparkle_img} width=40px; alt=''></span> </div>-->
{:else}

{#if habitats[i].ether == 1 }
<div style="width: 30px; height: 34px;"> <span class="text-electric-white"><img data-card-id={i} src="https://app.mebots.xyz/img/dark_matter_500.png" width=30px height=34px style="border-radius: 3px;" alt=''></span> </div>
{:else}


{#if i == (cpos) }
<div class:live_pulsing={ show_is_live } style="width: 30px; height: 34px;" >
	<span class="text-electric-white1">
		<img data-card-id={i} style="position: absolute; top: 0; left: 0; border-radius: 3px; z-index: 1;" src="https://app.mebots.xyz/img/map-center-500.png" width=30px height=30px alt=''>
		<span data-card-id={i} style="position: absolute; top: 0; left: 0;  width: 30px; height: 30px; z-index: 100; ">📍</span>
		<span data-card-id={i} style="position: absolute; top: 20px; left: 0;  width: 30px; height: 30px; z-index: 10; color: hsl(191, 100%, 100%); font-size: 10px;">Setup</span>
	</span>

	{#if embark['em'] == '' && is_anon == 0 }
	<span data-card-id={i} class="ego">
		<img data-card-id={i}  src={ mebot_img_url } width=30px height=30px alt=''>
	</span>
	{/if}

</div>
{:else}
<div style="width: 30px; height: 34px;"> <span class="text-electric-white"><div data-card-id={i}>&nbsp;</div></span> </div>
{/if}

{/if}

{/if}

{/if}
{:else}

{#if i == (40) && i != (cpos) }
<div style="width: 30px; height: 34px;"> <span class="text-electric-white"><img data-card-id={i} src="https://app.mebots.xyz/img/map-center-500.png" width=30px height=34px style="border-radius: 3px;" alt=''></span> </div>
{:else if i == (cpos) }

<div class:live_pulsing={ show_is_live } style="width: 30px; height: 34px;" >
	<span class="text-electric-white1">
		<img data-card-id={i} style="position: absolute; top: 0; left: 0; border-radius: 3px; z-index: 1;" src="https://app.mebots.xyz/img/map-center-500.png" width=30px height=30px alt=''>
		<span data-card-id={i} style="position: absolute; top: 0; left: 0;  width: 30px; height: 30px; z-index: 100; ">📍</span>
		<span data-card-id={i} style="position: absolute; top: 20px; left: 0;  width: 30px; height: 30px; z-index: 10; color: hsl(191, 100%, 100%); font-size: 10px;">Setup</span>
	</span>

	{#if embark['em'] == '' && is_anon == 0 }
	<span data-card-id={i} class="ego">
		<img data-card-id={i}  src={ mebot_img_url } width=30px height=30px alt=''>
	</span>
	{/if}
</div>

{/if}

<!--<div style="width: 22px; height: 22px;">
	<div data-card-id={i} style="padding-left: 4px; padding-right: 4px; margin-bottom: 10px; color: white;">⊚</div>
</div>-->
<!--<div style="width: 40px; height: 40px;"> <span class="text-electric-white"><img data-card-id={i}  src={sparkle_img} width=40px; alt=''></span> </div>-->
{/if}
								{/if}
								{#if s == -2 && found > 0}
								<div style="width: 40px; height: 40px;"> <span data-card-id={i} class="vertical-center2 text-electric-yellow-bolt" style="display: block; width: 40px; height: 40px; ">⚡</span> </div>
								{/if}
								{#if s == -3 && found > 0}
								<div style="width: 40px; height: 40px;"> <span data-card-id={i} class="vertical-center2 text-electric-white-clock" style="display: block; width: 40px; height: 40px; ">⌛</span> </div>
								{/if}
								{#if s == -4 && found > 0}
								<div style="width: 22px; height: 22px;"> <span data-card-id={i} class="vertical-center1 text-electric-zombie" style="width: 20px; height: 20px; ">🧟</span> </div>
								{/if}
								{#if s == -5 && found > 0}
								<div style="width: 40px; height: 40px; display: block;" > <span data-card-id={i} class="vertical-center1" style=" display: block; width: 20px; height: 20px; "><!--🌌--></span> </div>
								{/if}
								{#if s == -6 && found > 0}
								<div style="width: 22px; height: 22px;"> <span data-card-id={i} class="vertical-center1 text-electric-egg" style="width: 20px; height: 20px; ">🥚</span> </div>
								{/if}

							</div>
						</div>
					</div>
				</div>
			{/each}
		</div>

<!--		<center>
			<div class="small_row">
			<table width=300px>
				<tr height=20px>
					<td width=150px valign=middle>
						<span on:click={displaySpeedFactorInfo} class="text-electric info" style="white-space: nowrap;" >
							Speed factor:  <span class:flash={ is_flashing == true }><span class="text-electric-yellow">⚡</span> <span class:text-electric-red={ speed_factor <= 30 }> { (speed_factor <= 0 ? '💀' : speed_factor) } </span> </span>
						</span>
					</td>
					<td width=110px align=right> 
						<div style="height:1px;"></div>
						<span on:click={displayAutopilot} class="text-electric info" style="white-space: nowrap;" >Autopilot: {autopilot_level}&nbsp;</span>
					</td>
					<td width=40px valign=middle align=left>
						<div style="height:2px;"></div>
						<span class="text-electric info" style="white-space: nowrap;" >
							<Switch bind:checked={auto_roam}></Switch>
						</span>
					</td>
				</tr>

				<tr>
					<td width=150px valign=top>
						<span class="outer"><span class="speed_factor_progress_inner" style="width: {$progress_factor * 100}%"></span></span>
					</td>
					<td width=110px >&nbsp;</td>
					<td width=40px valign=middle></td>
				</tr>
			</table>
			</div>
		</center>-->

	{:else if (time_remaining <= 0 && mebot_winner_img_url.length >= 3) }
	<!--</a>-->
	<br>
	<center>
		<div class="small_row">
			<table width=300px><tr>
			<td width=150px align=left>
				<button class="menu_btn_home">
					<span class="leaderboard" >
						&nbsp; <span class="text-electric"> Results </span> &nbsp;
					</span>
				</button>
			</td>
			<td width=150px align=right>
				<a href="/#/move_leaderboard/{dash_token}/{mebot_id}/1">
					<button class="menu_btn_home">
					<span class="leaderboard" >
						&nbsp;<span class="text-electric-yello">🏆</span> &nbsp; <span class="text-electri"> Leaderboard </span> &nbsp;
					</span>
					</button>
				</a>
			</td>
			</tr></table>
		</div>
	</center>
	<br>
	<center>
		<div class="snake_row" style="user-select: none; align-items: flex-end;" >
			<div in:fade|local={{duration: 450}}>
				<img on:click={ () => push('/stats/' + dash_token + '/' + mebot_id + '/' + mebot_winner_id[2]) } in:animateIn2|local
					src={mebot_winner_img_url[2]}
					width="85px"
					alt="meebot"
					style="user-select: none;"
				/>
				<br><br>
				<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=20px; alt=''><img src='/img/sparkle-zm1.png' width=20px; alt=''></span></span><br>
				<span class="text-electric-white">{mebot_winner_score[2]}</span>
			</div>
			<div in:fade|local={{duration: 300}}>
					<a href="/#/stats/{dash_token}/{mebot_id}/{mebot_winner_id[1]}">
					<img in:animateIn1|local
						src={mebot_winner_img_url[1]}
						width="170px"
						alt="meebot"
						style="user-select: none;"
					/>
					</a>
					<br>
					<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=20px; alt=''><img src='/img/sparkle-zm1.png' width=20px; alt=''><img src='/img/sparkle-zm1.png' width=20px; alt=''></span></span><br>
					<span class="text-electric-white">{mebot_winner_score[1]}</span>
				</div>
			<div in:fade|local={{duration: 600}}>
				<a href="/#/stats/{dash_token}/{mebot_id}/{mebot_winner_id[3]}">
				<img in:animateIn3|local
					src={mebot_winner_img_url[3]}
					width="85px"
					alt="meebot"
					style="user-select: none; align-items: flex-end;"
				/>
				</a>
				<br><br>
				<span class="text-electric" style="color:silver; margin-top: 0px;"><span class="text-electric-yellow"><img src='/img/sparkle-zm1.png' width=20px; alt=''></span></span><br>
				<span class="text-electric-white" style="margin-top: 10px;">{mebot_winner_score[3]}</span>
			</div>
		</div>
		<br>
	</center>

		<span on:click={restartGame} class="vitals_bold text-electric" style="font-size: 50px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">&#8634;</span>
	{/if}
</center>

<center>
<table width=330 border=0>
<tr height=10px width=330>
	<td width=70px align=left on:click={ () => zoomMap(0, default_zoom) }>
		{#if default_zoom != -1 && default_zoom != 0 }
		<button class="menu_btn_home_1" in:fade|local={{duration: 200}}>
			<span class="text-electric-zombie" style="font-size: 12px;" > { zoom_level_desc }  </span>
		</button>
		{/if}
	</td>
	<td width=70px align="center" on:click={ () => zoomMap(-1) }>
	<button class="menu_btn_home_bright" class:level_pulsing={ flash_minus } class:menu_btn_home_in={ zoom+20 <= 0 || show_is_live }>
		<span style="font-size: 22px;" >&nbsp; <b>-</b> &nbsp;</span>
	</button>
	</td>
	<td width=40px align="center" valign=middle on:click={ () => zoomMap(0) }>
		{#if center_image != ''}
		<button style="width: 46px; height: 46px; background: url('{center_image}') no-repeat scroll 0 0 transparent; background-size: 100% 100%; " class="menu_btn_home menu_btn_home_inactive menu_btn_center" class:live_pulsing_bg={ show_is_live }>
			<span class:live_pulsing={ show_is_live } class="text-electric" > &nbsp; </span>
		</button>
		{:else}
		<button style="width: 46px; height: 46px;" class="menu_btn_home menu_btn_home_inactive menu_btn_center" class:live_pulsing_bg={ show_is_live }>
			<span class:live_pulsing={ show_is_live } class="text-electric" > ⊚ </span>
		</button>
		{/if}
	</td>
	<td width=70px align="center" on:click={ () => zoomMap(1) }>
	<button class="menu_btn_home_bright" class:level_pulsing={ flash_plus } class:menu_btn_home_in={ zoom >= 2 || show_is_live } >
		<span style="font-size: 22px;" >&nbsp; <b>+</b> &nbsp;</span>
	</button>
	</td>
	<td valign=middle width=70px style="padding-bottom: 0px" align=right>
		<button class="menu_btn_home_invisible" class:level_pulsing_bg={ false }>
			<span class="text-electric" style="font-size: 12px;">
				<span in:fade|local={{duration: 200}}>🔍 Zoom<br> &nbsp;&nbsp;&nbsp;&nbsp;
					<span style="font-size: 14px;">
					{#if is_loading && !show_is_live }
					<span class:level_pulsing={ is_loading }><b>....</b> </span>
					{:else}
					{ (zoom == '2') ? 'max' : (zoom == '-20') ? 'min' : (zoom+20) }
					{/if}
					</span>
				</span>
			</span>
		</button>
	</td>
</tr>
</table>
<table height=10px width=330 border=0>
<tr width=330>
	{#if dash_token != '1' && dash_token != '2'}
		{#if journey['info'] != '' }
		<!--<td colspan=1 width=120px align="left" on:click={ showJourney } >-->
		<td colspan=1 width=120px align="center" valign=top>
			{@html journey['info'] }
		</td>
		{:else}
		<td colspan=1 width=120px align="left">
			<!--<span class="text-electric" style="font-size: 10px; white-space: nowrap;" on:click={ onShowHabitats } >&nbsp; <span in:fade|local={{duration: 200}}>{ hab_visited_today }  </span> </span>-->
		</td>
		{/if}
	<td align=center valign=top>
		<span on:click={fetchMapHabitats} class:level_pulsing={ is_loading } class="vitals_bold text-electric" style="font-size: 40px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">&#8634;</span>
	</td>
	<td colspan=1 width=120px align=right valign=top on:click={ showJourney }>
		{#if journey['distance'] != '' }
		<button class="menu_btn_mebots menu_mebots" style="margin-top: 4px;">
			{@html journey['distance'] }
		</button>
		{/if}
		<!--<span class="text-electric" style="font-size: 10px; white-space: nowrap;" on:click={ displayParsecDetails } > &nbsp;&nbsp; 🏃‍♂️ <span style="font-size: 6px;"> { total_dist_in_square } </span></span>-->
	</td>
	{/if}
</tr>
</table>


</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={true}>
</Modal>

<Modal
        show={$modal1}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={true}
		>
</Modal>

<style>

	.text-electric {
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px hsla(178, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}
	.text-electric_sm {
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}

	.text-electric-red {
		text-shadow: 0 0 32px rgba(255, 192, 192, 0.9),
			0 0 32px hsla(0, 100%, 63%, 0.98);
		font-family: arial;
		color: hsl(0, 98%, 66%);
	}

	.question {
		color: white;
		font-size: 18px;
		text-shadow: 0 0 40px rgba(195, 195, 195, 0.9),
			0 0 32px rgba(255, 255, 255, 0.98);
		font-family: arial;
	}

	.snake_row {
		display: flex;
		flex-wrap: wrap;
		width: 350px;
		justify-content: center;
		margin-bottom: 10px;
		background-size: contain;
		overscroll-behavior: none;
/*		background-image: url("/img/imageedit_1_613383927.png");*/
	}

	.snake_col {
		display: flex;
		flex-wrap: wrap;
		width: 350px;
		height: 350px;
		justify-content: center;
		margin-bottom: 10px;
		background-size: contain;
/*		background-image: url("/img/imageedit_1_613383927.png");*/
	}

	/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
	.flip-box {
		background-color: transparent;
		width: 36px;
		height: 36px;
		margin: 0 1px 2px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

	/* This container is needed to position the front and back side */
	.flip-box-inner {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.8s;
		transform-style: preserve-3d;
	}

	/* Position the front and back side */
	.flip-box-front,
	.flip-box-back {
		position: absolute;
		width: 100%;
		height: 100%;
		-webkit-backface-visibility: hidden; /* Safari */
		backface-visibility: hidden;
	}

	/* Style the front side */
	.flip-box-front1 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(192, 212, 255, 0.1)
	}
	.flip-box-front2 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(255, 192, 252, 0.1)
	}
	.flip-box-front3 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(255, 230, 192, 0.279)
	}
	.flip-box-front4 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		background-color: rgba(192, 204, 255, 0.44)
	}

	.flip-box-found {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		/*background-color: #57d5f1;*/
		background-color: rgba(17, 13, 35, 0.447)	
	}
	.flip-box-found1 {
		/*		background-color: rgba(247, 233, 26, 0.932);*/
		/*background-color: #57d5f1;*/
		background-color: #200d23;
	}

	.flip_box_border1 {
		background-color: rgba(7, 7, 31, 0.236);
/*		background-color: rgba(27, 255, 232, 0.678);*/
/*		background-color: rgba(25, 227, 227, 0.678)*/
	}
	.flip_box_border2 {
		background-color: rgba(252, 51, 255, 0.678);
	}
	.flip_box_border3 {
		background-color: rgba(255, 156, 27, 0.915);
	}
	.flip_box_border4 {
		background-color: rgba(27, 69, 255, 0.758);
	}
	.visited-background {
		background-color: #00ff95;
	}
	.mayor-background {
		/*background-color: #ffbf00;*/
		background-color: #ffee00;
	}
	.undis-background {
		background-color: #0091ff;
	}
	.ether-background {
		background-color: #000516;
	}

	.text-green {
		color: #1bffe8ee;
	}

	.vertical-center {
		margin: 0;
		position: absolute;
		top: 56%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.vertical-center1 {
		margin: 0;
		position: absolute;
		top: 30%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.vertical-center2 {
		margin: 0;
		position: absolute;
		top: 70%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.text-electric-yellow {
		text-shadow: 0 0 5px rgba(255, 229, 61, 0.9),
			0 0 8px rgba(255, 239, 65, 0.98);
		font-family: arial;
		color: hsl(61, 97%, 75%);
	}
	.text-electric-yellow-bolt {
		text-shadow: 0 0 5px rgba(255, 229, 61, 0.9),
			0 0 20px rgba(255, 239, 65, 0.98);
		font-family: arial;
		color: hsl(61, 97%, 75%);
	}
	.text-electric-white {
		text-shadow: 0 0 5px rgba(253, 253, 253, 0.9),
			0 0 8px rgba(252, 252, 252, 0.98);
		font-family: arial;
		color: hsl(60, 19%, 88%);
	}
	.text-electric-collected {
		text-shadow: 0 0 5px rgb(0, 97, 81),
			0 0 8px rgb(0, 97, 81);
		font-family: arial;
		/*color: #03f34fb3;*/
		color: #1bffe8c9;
		/*color: rgb(0, 209, 174);*/
	}

	.text-electric-collected-grad {
		text-shadow: 0 0 5px rgb(0, 97, 81),
			0 0 8px rgb(0, 97, 81);
		font-family: arial;
		-webkit-animation: color_chage 2s normal forwards ease-in-out;
		-moz-animation: color_chage 2s normal forwards ease-in-out;
		-o-animation: color_chage 2s normal forwards ease-in-out;
		animation: color_chage 2s normal forwards ease-in-out;
	}
	@keyframes color_chage {
		0% {color: #e6e6db;}
		100% {color: #1bffe8c9;}
	}

	.text-electric-white-clock {
		text-shadow: 0 0 5px rgba(253, 253, 253, 0.9),
			0 0 20px rgba(252, 252, 252, 0.98);
		font-family: arial;
		color: rgb(230, 230, 219);
	}
	.text-electric-zombie {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(5, 255, 130, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
		animation: zombie-pulse 5.4s;
	}
	.text-electric-dark {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(5, 255, 130, 0.98);
		font-family: arial;
		color: hsl(0, 0%, 100%);
		animation: zombie-pulse 5.4s;
	}
	.text-electric-egg {
		text-shadow: 0 0 5px rgba(255, 255, 192, 0.7),
			0 0 10px rgba(251, 255, 29, 0.968);
		font-family: arial;
		color: hsl(70, 97%, 75%);
		animation: egg-pulse 3.5s infinite;
	}

	@keyframes egg-pulse {
	0% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(255, 251, 5, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}

	10% {
		text-shadow: 0 0 32px rgba(249, 192, 255, 0.9),
			0 0 15px #b93ffffa;
		color: hsl(294, 97%, 75%);
	}

	100% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(251, 255, 5, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}
	}

	.text-electric-wormhole {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(255, 29, 191, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		animation: zombie-wormhole 2.5s infinite;
		background-color: rgba(252, 51, 255, 0.678);
	}
	@keyframes zombie-pulse {
	0% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(5, 255, 130, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}

	10% {
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
			0 0 15px rgba(249, 255, 65, 0.98);
		color: hsl(189, 97%, 75%);
	}

	100% {
		text-shadow: 0 0 5px rgba(192, 255, 218, 0.9),
			0 0 10px rgba(5, 255, 130, 0.98);
		font-family: arial;
		color: hsl(144, 97%, 75%);
	}
	}

	@keyframes zombie-wormhole {
	0% {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(255, 29, 191, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		background-color: rgba(252, 51, 255, 0.678);
	}

	10% {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(3, 158, 247, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		background-color: rgba(51, 228, 255, 0.959);
	}

	100% {
		text-shadow: 0 0 5px rgba(239, 192, 255, 0.7),
			0 0 10px rgba(255, 29, 191, 0.7);
		font-family: arial;
		color: hsl(295, 97%, 75%);
		background-color: rgba(252, 51, 255, 0.678);
	}
	}

.text-electric-location1 {
	background-color: #00d9ff;
}
.text-electric-location2 {
    background: linear-gradient(129deg, #725cd8, #00d9ff, #090033, #ff0000);
    background-size: 800% 800%;

    -webkit-animation: AnimationName 1.8s ease infinite;
    -moz-animation: AnimationName 1.8s ease infinite;
    -o-animation: AnimationName 1.8s ease infinite;
    animation: AnimationName 1.8s ease infinite;
}

.text-electric-wormhole2 {
    background: linear-gradient(129deg, #725cd8, #ff8300, #090033, #ff0000);
    background-size: 800% 800%;

    -webkit-animation: AnimationName 1.8s ease infinite;
    -moz-animation: AnimationName 1.8s ease infinite;
    -o-animation: AnimationName 1.8s ease infinite;
    animation: AnimationName 1.8s ease infinite;
}

@-webkit-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}
@-moz-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}
@-o-keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}
@keyframes AnimationName {
    0%{background-position:62% 0%}
    50%{background-position:39% 100%}
    100%{background-position:62% 0%}
}

	.message {
		margin: 0;
		position: absolute;
		top: 50%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	img {
		max-height: 90%;
	}

	.card {
		border-radius: 4px;
		color: rgb(216, 79, 0);
		box-shadow: 0 4px 8px 0 rgba(189, 140, 104, 0.2);
	}

	.card-miami {
		background-color: #a341ff96;
	}
	.card-nyc {
		background-color: #f1fe3daf;
	}

	.card-active {
		border-radius: 4px;
		color: rgb(5, 20, 32);
		background-color: rgba(246, 20, 250, 0.839);
		box-shadow: 0 0px 8px 0 rgb(173, 166, 161);
	}
	.card-active-owner {
		background-color: #00ff95;
	}
	.card-active-owner-menu {
		background-color: #00ff95bb;
	}
	.card-active-non-owner-menu {
		background-color: #f614faad;
	}
	.card-active-active-owner {
		background-color: #00d9ff;
	}
	.card-active-pulse {
		background-color: rgba(65, 255, 249, 0.831);
	}
	@keyframes pulse-active {
	0% {
		background-color: rgba(65, 255, 249, 0.69);
	}

	10% {
		background-color: rgba(65, 255, 249, 0.442);
	}

	100% {
		background-color: rgba(36, 255, 200, 0.69);
	}
	}

	.card-other-mebot-active{
		opacity: .9;
	}

	.small_row {
        width: 300px;
		margin-bottom: 10px;
		margin-left: 32px;
		margin-right: 36px;
	}
	.info {
		font-size: 16px;
		justify-content: left;
	}
	.info-sm {
		font-size: 14px;
		justify-content: left;
	}
	.info-extra {
		font-size: 10px;
		justify-content: left;
	}

	.small_row .steps {
		color:rgba(195, 195, 195, 0.643);
        float: right;
		white-space: nowrap;
    }

	.info-pulsing-big {
		font-weight: bold;
		animation: pulse-big 1.3s infinite;
	}
	@keyframes pulse-big {
	0% {
		transform: scale(1.2);
	}

	10% {
		transform: scale(1.8);
	}

	100% {
		transform: scale(1.2);
	}
	}

	.info-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: pulse 1.3s infinite;
	}

	@keyframes pulse {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.2);
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
		0 0 32px rgba(249, 255, 65, 0.98);
		color: hsl(53, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.info-pulsing-zombie {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.1s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.5);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsl(167, 97%, 75%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}


	.info-time-pulsing {
		transform: scale(1);
		animation: time-pulse 1s infinite;
	}

	@keyframes time-pulse {
	0% {
		text-shadow: 0 0 32px rgba(241, 253, 254, 0.9),
			0 0 32px rgba(234, 254, 254, 0.98);
		color: hsl(187, 100%, 98%);
	}

	10% {
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
			0 0 32px rgba(249, 255, 65, 0.98);
		color: hsl(53, 97%, 75%);
	}

	100% {
		text-shadow: 0 0 32px rgba(242, 254, 254, 0.9),
			0 0 32px rgba(230, 238, 237, 0.98);
		color: hsl(180, 19%, 95%);
	}
	}

	body {
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.flash {
		font-weight: bold;
		transform: scale(1);
		animation: flash-pulse 0.4s infinite;
	}

	@keyframes flash-pulse {
	0% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px #41fff9fa;
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.2);
		text-shadow: 0 0 32px rgba(255, 248, 192, 0.9),
			0 0 32px rgba(249, 249, 249, 0.98);
		color: hsl(0, 0%, 100%);
	}

	100% {
		transform: scale(0.95);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.menu_btn_home {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #d1f5f88e;
		color: rgba(255, 255, 255, 1);
		box-shadow: 0 5px 15px rgba(211, 214, 215, 0.673);
	}
	.menu_btn_home_bright {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: hsla(178, 100%, 63%, 0.905);
		color: rgb(0, 0, 0);
		box-shadow: 0 5px 15px rgba(211, 214, 215, 0.673);
	}
	.menu_btn_home_in {
		background-color: #d1f5f88e;
	}
	.menu_btn_help {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.menu_btn_visited {
		background-color: #00ff95;
	}
	.menu_btn_controlled{
		background-color: #ffee00;
	}
	.menu_btn_clear {
		background-color: #00b7ff22;
	}
	.menu_btn_clear2 {
		border: 1px solid rgba(211, 214, 215, 0.01);
		background-color: rgba(211, 214, 215, 0.01);
	}
	.menu_btn_city {
    	background: linear-gradient(129deg, #55f6ff, #76eaff, #090033, #ff0000);
    	background-size: 800% 800%;
	}


	.menu_btn_miami{
		/*background-color: #A74099;*/
		/*background-color: #4064a7;*/
		background-color: #3498db;
	}
	.menu_btn_nyc{
		/*background-color: #9b59b6;*/
		background-color: #ec9c08;
	}

	.menu_btn_home_1 {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #20202025;
		color: rgba(255, 255, 255, 1);
		box-shadow: 0 5px 15px rgba(211, 214, 215, 0.673);
	}
	.menu_btn_home_inactive {
		background-color: #20202025;
	}
	.menu_btn_center {
		background-color: #41fff906;
	}
	.menu_btn_home_invisible {
		border: 0px;
		border-radius: 5px;
		background-color: #20202025;
	}

	.leaderboard {
		font-size: 12px;
	}

	progress {
		height: 2px;
		display: block;
		width: 100%;
		border: 1px;
	}

	.progress_inner, .speed_factor_progress_inner, .outer {
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner {
		background-color: #725cd8;
		display: block;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.outer {
		margin: 0px;
		background-color: transparent;
		border: 0px;
	}

	.speed_factor_progress_inner {
		background-color: rgba(27, 255, 232, 0.847);
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		display: block;
	}

	.balance-pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.6s infinite;
	}

	.level_pulsing_bg {
		background: linear-gradient(129deg, #5cd8b779, #00d9ff85, #090033, #ff0000);
	    background-size: 800% 800%;

    	-webkit-animation: AnimationName 1.8s ease infinite;
	    -moz-animation: AnimationName 1.8s ease infinite;
    	-o-animation: AnimationName 1.8s ease infinite;
    	animation: AnimationName 1.8s ease infinite;
	}

	.level_pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 0.6s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(1);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}

	10% {
		transform: scale(1.3);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
		color: hsla(167, 97%, 75%, 0);
	}

	100% {
		transform: scale(1);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
		color: hsl(185, 97%, 75%);
	}
	}

	.level_pulsing1 {
		animation: zombie-fight1 0.4s infinite;
	}
	@keyframes zombie-fight1 {
	0% {
		color: hsl(185, 97%, 75%);
	}

	10% {
		color: hsla(167, 97%, 75%, 0);
	}

	100% {
		color: hsl(185, 97%, 75%);
	}
	}

	.live_pulsing_bg {
		background-color: #55f6fff4;
		font-color: rgb(255, 255, 255);
	}
	.live_pulsing {
		font-weight: bold;
		transform: scale(1);
		animation: zombie-fight 1.4s infinite;
	}
	@keyframes zombie-fight {
	0% {
		transform: scale(1);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
			color: hsl(0, 0%, 100%);
	}

	10% {
		transform: scale(1.1);
		text-shadow: 0 0 32px rgba(192, 255, 220, 0.9),
			0 0 32px rgba(65, 255, 170, 0.98);
			color: hsl(191, 100%, 50%);
	}

	100% {
		transform: scale(0.7);
		text-shadow: 0 0 32px rgba(192, 253, 255, 0.9),
			0 0 32px rgba(65, 255, 249, 0.98);
			color: hsl(185, 97%, 75%);
	}
	}

	.dark-matter {
		background: linear-gradient(60deg, rgb(5, 32, 41), #010102, #091f3e, #000000ee);
		background-size: 1000% 1000%;

		-webkit-animation: AnimationName 7s ease infinite;
		-moz-animation: AnimationName 7s ease infinite;
		-o-animation: AnimationName 7s ease infinite;
		animation: AnimationName 7s ease infinite;
	}

	.menu_btn_mebots {
		font-size: 14px;
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 6px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}

	.menu_btn_mebots_rounded {
		font-size: 14px;
		border-radius: 8px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 6px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}

	.menu_active {
		background-color: #2ffff1d6;
		box-shadow: 0 5px 15px rgb(231, 247, 255);
    }

	.menu_mebots_mode_active {
		background-color: #028dff;
	}

	.menu_mebots_state_active {
		background-color: #03b9a6;
	}

	.menu_mebots_state_active_active {
		background-color: #00ead3;
	}

	.menu_mebots_energy_active1 {
		background-color: #03a135;
	}
	.menu_mebots_energy_active {
		background-color: #03f34fd3;
	}

	.menu_mebots_col_energy_active {
		background-color: #c4f4d3;
	}

	.menu_mebots {
		background-color: #00559a;
	}

/*	.artifact__badge {
		background-color: rgb(0, 166, 181);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 6px;

		position: absolute;
		top: 18px;
		right: -3px;
	}*/
	.habitat__badge_gem {
		background-color: #3498db;
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute;
		top: 17px;
		right: -3px;
		z-index: 1000;
	}

	.mebot_player {
		z-index: 5000;
	}

	.habitat__badge_gem_shine_artifact {
		background-color: #55f6ff;
		border-radius: 5px;
		border: 0px solid white;
		color: rgb(0, 0, 0);
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 4px 4px;
		font-size: 18px;

		position: absolute;
		top: 0px;
		right: 0px;
		z-index: 1000;
		width: 22px; height: 24px;
	}

	.habitat__map_menu_artifact {
		background-color: #55f6ffee;
		border-radius: 5px;
		border: 0px solid white;
		color: rgb(0, 0, 0);
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 4px 4px;
		font-size: 18px;

		position: absolute;
		bottom: 24px;
		right: 0px;
		z-index: 1000;
		width: 22px; height: 24px;
	}

	.ego {
 	    background: rgb(255, 140, 0);
		border-radius: 5px;
		padding: 0px 0px;
		position: absolute;
		bottom: 4px;
		right: 0px;
		z-index: 2000;
		width: 30px; height: 30px;
	}

	.darken1 {
		background: black;
		opacity: 0.2;
	}

	.habitat__badge_gem_shine_tr {
		background-color: #252525c4;
		border-radius: 5px;
		border: 0px solid white;
		color: rgb(0, 0, 0);
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 12px;

		position: absolute;
		top: 0px;
		right: -3px;
		z-index: 1000;
	}

	.habitat__badge_se1 {
		background-color: rgba(255, 117, 4, 0.636);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(255, 149, 0), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute;
		top: 17px;
		right: 18px;
		z-index: 1000;
	}

	.habitat__badge_se2 {
		background-color: rgba(0, 69, 206, 0.459);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 132, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 14px;

		position: absolute;
		top: 14px;
		right: -3px;
		z-index: 2501;
	}

	.habitat__badge_mebot {
		background-color: rgba(0, 69, 206, 0.459);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 132, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 14px;

		position: absolute;
		top: 18px;
		right: -3px;
		z-index: 2500;
	}

	.cities__badge {
		background-color: rgb(20, 20, 20);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -5px;
		right: -5px;
	}

    .claim_active {
        background: linear-gradient(114deg, rgb(109, 34, 0), rgb(49, 19, 108), #42e3ff, #42e3ffee);
	    background-size: 800% 800%;

		-webkit-animation: AnimationName 2.5s ease infinite;
		-moz-animation: AnimationName 2.5s ease infinite;
		-o-animation: AnimationName 2.5s ease infinite;
		animation: AnimationName 2.5s ease infinite;
	}
	@-webkit-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-moz-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@-o-keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}
	@keyframes AnimationName {
		0%{background-position:0% 71%}
		50%{background-position:100% 30%}
		100%{background-position:0% 71%}
	}

	.energy_items__badge {
		background-color: #03f34f;
		border-radius: 5px;
		border: 0px solid white;
		color: rgb(0, 0, 0);
		box-shadow: 0 0 8px rgb(220, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -5px;
		right: -5px;
	}

	.mebots__badge {
		background-color: rgb(20, 20, 20);
		border-radius: 5px;
		border: 0px solid white;
		color: white;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);

		padding: 2px 4px;
		font-size: 10px;

		position: absolute; /* Position the badge within the relatively positioned button */
		top: -5px;
		right: -5px;
	}

	.main1 {
		position: absolute;
		margin-left: auto; 
		margin-right: auto;
		display: inline;
		border-radius: 10px;
		background-color: #0b2d49f5;
		height: 450px;
		width: 340px;
		overflow-x: hidden;
		overflow-y: auto;
		text-align: left;
		padding: 0px;
		overscroll-behavior: auto;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		z-index: 10000;
	}

	.main1::-webkit-scrollbar {
		display: none;
	}

	.main1-square {
		position: absolute;
		margin-left: auto; 
		margin-right: auto;
		display: inline;
		border-radius: 10px;
		background-color: #051420f5;
		height: 450px;
		width: 340px;
		overflow-x: hidden;
		overflow-y: auto;
		text-align: left;
		padding: 0px;
		overscroll-behavior: auto;
		border: none;
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		z-index: 10000;
	}

	.main1-square::-webkit-scrollbar {
		display: none;
	}

	.mebots-flip-box {
		background-color: transparent;
		width: 95px;
		height: 130px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}
	.mebot-byline {
		font-size: 10px;
	}
	.text-glow-blueish {
		text-shadow: 0 0 10px rgb(192 219 255 / 75%),
			0 0 32px rgb(65 120 255 / 88%);
		font-family: arial;
		color: hsl(185, 97%, 75%);
	}

	.modes-flip-box {
		background-color: transparent;
		width: 90px;
		height: 76px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

	.energy-flip-box {
		background-color: transparent;
		width: 102px;
		height: 90px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
	}

	.energy-collect-flip-box {
		background-color: transparent;
		width: 130px;
		height: 90px;
		margin: 0 0px 0px 0px;
		border: 0px solid #f1f1f1;
	}

	.outer_daily_power {
		margin: 0px;
		background-color: transparent;
		border: 0px;
		box-shadow: 0 0 8px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}

	.progress_inner_daily_power {
		background-color: #1bffe8ee;
		display: block;
		box-shadow: 0 0 8px rgb(255, 255, 0), 0 0 20px rgba(130, 132, 132, 0.819);
		height: 2px;
		border-radius: 0px;
	}
</style>
